/* ============================================================
   Klintensiv B2B — logged-in chrome interactions
   Drives the logged-in app-bar header (.klh2) and footer (.klf2):
     • .klh2 → scrolled shadow/shrink, dropdown popovers (location,
       notifications, account), location pick, click-outside close.
     • .klf2 → mobile column accordion + "back to top".
   Self-guards against double-init (dataset flags) and re-runs on the
   theme editor's shopify:section:load, so live reload + multiple
   instances behave. Mirrors the prototype's header-v2 / FooterLogat.
   ============================================================ */
(function () {
  'use strict';

  /* Active locale root — '/' on the primary language, '/en/' on any other.
     Every storefront URL built in JS has to go through this: an unprefixed
     '/cart' drops the buyer back to the primary language, and an unprefixed
     '/cart.js' or '/products.json' returns UNTRANSLATED titles, so an English
     session would show Romanian product names. Shopify publishes the value on
     window.Shopify.routes.root, always with a trailing slash. */
  var KLD_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* path is given WITHOUT a leading slash: kldUrl('cart') -> '/en/cart' */
  function kldUrl(path) { return KLD_ROOT + path; }

  /* Translate known Shopify SERVER cart messages (returned by the Cart AJAX API
     in the store's active storefront language — English here) to Romanian.
     Exposed on window so assets/cart.js (Dawn) can reuse it for the cart-drawer
     line-item error, which prints the raw server string. Unknown messages pass
     through unchanged. Root-cause alternative: set the storefront language to RO
     so Shopify returns all such messages localized automatically. */
  window.kldRoCartMessage = function (msg) {
    if (typeof msg !== 'string') return msg;
    var m = msg.match(/^\s*only\s+([\d.,]+)\s+items?\s+were added to your cart due to availability\.?\s*$/i);
    if (m) return 'Doar ' + m[1] + ' buc. au fost adăugate în coș din cauza stocului disponibil.';
    return msg;
  };

  function initHeader(root) {
    if (!root || root.dataset.klh2Bound) return;
    root.dataset.klh2Bound = '1';

    /* scrolled state */
    var onScroll = function () { root.classList.toggle('scrolled', window.scrollY > 10); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-klh2-panel]'));
    var closeAll = function (except) {
      panels.forEach(function (p) { if (p !== except) p.classList.remove('open'); });
    };

    /* toggle buttons */
    root.querySelectorAll('[data-klh2-toggle]').forEach(function (btn) {
      var key = btn.getAttribute('data-klh2-toggle');
      var panel = root.querySelector('[data-klh2-panel="' + key + '"]');
      if (!panel) return; /* e.g. launcher has no panel */
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !panel.classList.contains('open');
        closeAll();
        if (willOpen) panel.classList.add('open');
      });
    });

    /* Location pick is REAL: each item is a link to Shopify's
       url_to_set_as_current, which sets customer.current_location server-side
       and reloads. No client-side label swapping — that would show a location
       the buyer isn't actually purchasing for, which is how the old cosmetic
       switcher hid a broken B2B session. */

    /* notifications read-state (amber dot). Persist "read" per content signature in
       localStorage so a returning buyer isn't nagged, but a NEW notification
       (changed signature → new/edited blocks) re-lights the dot. "Mark as read" and
       opening any notification clear it immediately. Degrades gracefully with no
       localStorage: the dot simply stays lit. */
    var notifBell = root.querySelector('[data-klh2-toggle="notif"]');
    var notifDot = root.querySelector('[data-klh2-notif-dot]');
    if (notifBell && notifDot) {
      var notifSig = notifBell.getAttribute('data-klh2-notif-sig') || '';
      var NOTIF_KEY = 'klh2:notifRead';
      var storedSig = null;
      try { storedSig = window.localStorage.getItem(NOTIF_KEY); } catch (e) {}
      if (storedSig === notifSig) notifDot.style.display = 'none';
      var markNotifRead = function () {
        notifDot.style.display = 'none';
        try { window.localStorage.setItem(NOTIF_KEY, notifSig); } catch (e) {}
      };
      root.querySelectorAll('[data-klh2-notif-read]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); markNotifRead(); });
      });
      root.querySelectorAll('.klh2-notif__item').forEach(function (a) {
        a.addEventListener('click', markNotifRead);
      });
    }

    /* click-outside + escape */
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
      else if (!e.target.closest('[data-klh2-panel]') && !e.target.closest('[data-klh2-toggle]')) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    /* bar-2 hover mega menus */
    var bar2 = root.querySelector('[data-klh2-bar2]');
    if (bar2) {
      var megaPanels = Array.prototype.slice.call(bar2.querySelectorAll('[data-klh2-mega-panel]'));
      var megaTriggers = Array.prototype.slice.call(bar2.querySelectorAll('[data-klh2-mega]'));
      var closeMega = function () {
        megaPanels.forEach(function (p) { p.classList.remove('open'); });
        megaTriggers.forEach(function (t) { t.classList.remove('open'); });
      };
      megaTriggers.forEach(function (trigger) {
        var panel = bar2.querySelector('[data-klh2-mega-panel="' + trigger.getAttribute('data-klh2-mega') + '"]');
        trigger.addEventListener('mouseenter', function () {
          closeMega();
          if (panel) { panel.classList.add('open'); trigger.classList.add('open'); }
        });
        if (panel) panel.addEventListener('mouseenter', function () { panel.classList.add('open'); trigger.classList.add('open'); });
      });
      /* hovering a plain link or the right-side actions clears the mega */
      bar2.querySelectorAll('.klh2-navlink:not([data-klh2-mega]), .klh2-actions').forEach(function (el) {
        el.addEventListener('mouseenter', closeMega);
      });
      bar2.addEventListener('mouseleave', closeMega);

    }

    initNavDrawer(root);
    initCartDrawer(root);
  }

  /* Mobile shopping drawer (.klh2-drawer): full-height off-canvas copy of the
     bar-2 nav. The trigger is display:none above 980px, so binding it
     unconditionally is harmless — it simply can't be reached on desktop.
     [hidden] is toggled around the transition so the panel is fully out of the
     accessibility tree (and untabbable) while closed, instead of merely
     translated off-screen. */
  function initNavDrawer(root) {
    var toggle = root.querySelector('[data-klh2-navtoggle]');
    if (!toggle) return;
    /* the drawer is a sibling of <header class="klh2">, not a child, so resolve
       it through the trigger's aria-controls rather than from `root` */
    var drawer = document.getElementById(toggle.getAttribute('aria-controls') || '') ||
      (root.parentNode && root.parentNode.querySelector('[data-klh2-drawer]'));
    if (!drawer) return;

    /* Hoist the drawer to <body>. Shopify wraps every header-group section in
       `.shopify-section-group-header-group`, which Dawn's base.css pins at
       `z-index: 4` — so ANY descendant, however high its own z-index, is capped
       at 4 against the rest of the page. That is why Matrix Order's sticky bar
       (`.kld-mxm__bar`, fixed, z-index 40) painted over the panel. Re-parenting
       is the only fix that is immune to whatever the wrapper does; the drawer is
       self-contained (its --k2-* tokens are declared on .klh2-drawer itself, not
       inherited from .klh2), so it survives the move. */
    Array.prototype.slice.call(document.querySelectorAll('body > [data-klh2-drawer]'))
      .forEach(function (stale) { if (stale !== drawer && stale.parentNode) stale.parentNode.removeChild(stale); });
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

    var panel = drawer.querySelector('.klh2-drawer__panel');
    var closeTimer = null;
    var isOpen = function () { return drawer.classList.contains('is-open'); };

    var open = function () {
      if (isOpen()) return;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      drawer.hidden = false;
      /* next frame, so the transform/opacity transition actually runs */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      });
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      kldHidePandectes(true);
      if (panel) panel.scrollTop = 0;
    };

    var close = function (returnFocus) {
      if (!isOpen()) return;
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      kldHidePandectes(false);
      if (returnFocus) toggle.focus();
      closeTimer = setTimeout(function () { drawer.hidden = true; }, 300);
    };

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isOpen()) close(false);
      else open();
    });

    drawer.addEventListener('click', function (e) {
      /* mega rows are accordion headers, not links: they expand their category
         panel in place (the desktop hover mega has no mobile equivalent) and
         must NOT fall through to the close branch below */
      var subToggle = e.target.closest('[data-klh2-subtoggle]');
      if (subToggle) {
        var group = subToggle.closest('[data-klh2-drawer-group]');
        var sub = group && group.querySelector('[data-klh2-drawer-sub]');
        if (!sub) return;
        var willOpen = sub.hidden;
        sub.hidden = !willOpen;
        group.classList.toggle('is-open', willOpen);
        subToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      /* scrim + × share the same hook; a link tap closes so a cached back-nav
         doesn't restore the page with the drawer still hanging open */
      if (e.target.closest('[data-klh2-drawer-close]') ||
          e.target.closest('.klh2-drawer__link') ||
          e.target.closest('.klh2-drawer__sublink')) {
        close(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close(true);
    });

    /* a resize past the breakpoint leaves the drawer orphaned — the desktop nav
       is inline again, so drop it rather than trapping scroll */
    window.addEventListener('resize', function () {
      if (window.innerWidth > 980) close(false);
    });
  }

  /* Cart UI is Dawn's built-in <cart-drawer> (rendered in theme.liquid, cart_type
     = drawer). The custom header cart buttons ([data-klh2-cart-toggle]) open it;
     the custom badge ([data-klh2-cart-count]) is kept in sync from the live cart
     (kldRefreshBadge — on load and on PUB_SUB cartUpdate). If no cart-drawer is on
     the page, the buttons fall back to their /cart link. */
  function initCartDrawer(root) {
    root.querySelectorAll('[data-klh2-cart-toggle]').forEach(function (btn) {
      if (btn.dataset.klh2CartBound) return;
      btn.dataset.klh2CartBound = '1';
      btn.addEventListener('click', function (e) {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') { e.preventDefault(); d.open(btn); }
      });
    });
  }

  /* Set / refresh the custom cart badge(s): the bar-2 cart button and the
     mobile bottom-tab cart. Matched on the data hook alone so any future badge
     just needs [data-klh2-cart-count]. */
  function kldSetCartBadge(n) {
    document.querySelectorAll('[data-klh2-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }
  var kldLastCount = null;
  /* Refresh the badge from the live cart. When detectAdd is true and the item
     count went UP since last seen, pop the "added to cart" toast. */
  function kldRefreshBadge(detectAdd) {
    if (!window.fetch) return;
    fetch(kldUrl('cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        kldSetCartBadge(c.item_count);
        if (detectAdd && kldLastCount !== null && c.item_count > kldLastCount) kldShowCartToast();
        kldLastCount = c.item_count;
      })
      .catch(function () {});
  }

  /* Bottom-left "product added" toast. The whole toast is clickable → opens
     Dawn's cart-drawer; the × dismisses. Auto-hides after a few seconds; only one
     at a time. Suppressed while the drawer is already open (it's redundant then).
     Triggered from kldRefreshBadge on any cart increase — i.e. the card + button
     (quick-add-bulk), the bulk modal, etc. */
  function kldShowCartToast() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return;
    var prev = document.querySelector('.kld-carttoast');
    if (prev && prev.parentNode) prev.parentNode.removeChild(prev);

    var t = document.createElement('div');
    t.className = 'kld-carttoast';
    t.setAttribute('role', 'status');
    t.innerHTML =
      '<span class="kld-carttoast__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
      '<span class="kld-carttoast__txt">Produsul a fost adăugat în coș. <span class="kld-carttoast__link">Vezi coșul</span></span>' +
      '<button type="button" class="kld-carttoast__x" aria-label="Închide">&times;</button>';
    document.body.appendChild(t);

    var hideTimer;
    var dismiss = function () {
      clearTimeout(hideTimer);
      t.classList.remove('is-show');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    };
    t.addEventListener('click', function (e) {
      if (e.target.closest('.kld-carttoast__x')) { e.stopPropagation(); dismiss(); return; }
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open();
      dismiss();
    });
    requestAnimationFrame(function () { t.classList.add('is-show'); });
    hideTimer = setTimeout(dismiss, 5000);
  }

  /* Dawn's <cart-drawer> element (present when cart_type = drawer). */
  function kldDawnDrawer() { return document.querySelector('cart-drawer'); }

  /* AJAX-add `items` ([{id,quantity}]) and reveal Dawn's cart-drawer.

     Two deterministic steps instead of relying on /cart/add.js's inline section
     render: (1) add the items, then (2) pull the FRESH drawer HTML from the
     Section Rendering API (GET /?sections=…) and hand it to renderContents. The
     drawer is cart-global, so rendering it against the index context avoids the
     empty/blank #CartDrawer we get when add.js renders it with sections_url set
     to a login-gated custom page (e.g. /pages/quick-order). Syncs the custom
     header badge. Falls back to the cart page when the drawer / a step fails.
     Returns a promise. */
  function kldDawnAdd(items, opener, cartUrl) {
    if (!items || !items.length) return;
    if (!window.fetch) { window.location.href = cartUrl || kldUrl('cart'); return; }
    var d = kldDawnDrawer();
    return fetch(kldUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) { return r.json().then(function (x) { throw x; }); } return r.json(); })
      .then(function (res) {
        if (!d || typeof d.renderContents !== 'function') {
          window.location.href = cartUrl || kldUrl('cart');
          return res;
        }
        d.setActiveElement(opener || document.activeElement);
        var ids = (typeof d.getSectionsToRender === 'function'
          ? d.getSectionsToRender().map(function (s) { return s.id; })
          : ['cart-drawer', 'cart-icon-bubble']).join(',');
        return fetch(window.Shopify && Shopify.routes && Shopify.routes.root
            ? Shopify.routes.root + '?sections=' + encodeURIComponent(ids)
            : '/?sections=' + encodeURIComponent(ids), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (sections) {
            var html = sections && sections['cart-drawer'];
            if (html) {
              /* The <cart-drawer> HOST was rendered `is-empty` at page load (empty
                 cart), and Dawn's renderContents only clears `is-empty` on the
                 inner .drawer__inner — never on the host. Left on, open() looks for
                 `.drawer__inner-empty` (gone once populated) → trapFocus(null)
                 throws, and the CSS is-empty state paints the header/items blank.
                 Mirror the FRESH render's own host state onto the live host (the
                 authoritative source) so open() picks the right focus container. */
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              var freshHost = tmp.querySelector('cart-drawer');
              if (freshHost) d.classList.toggle('is-empty', freshHost.classList.contains('is-empty'));
              d.renderContents({ sections: sections });
            } else if (typeof d.open === 'function') {
              d.classList.remove('is-empty');
              d.open(opener);
            }
            kldRefreshBadge();
            return res;
          })
          .catch(function () {
            d.classList.remove('is-empty');
            if (typeof d.open === 'function') { d.open(opener); }
            kldRefreshBadge();
            return res;
          });
      });
  }

  function initFooter(root) {
    if (!root || root.dataset.klf2Bound) return;
    root.dataset.klf2Bound = '1';

    /* back to top */
    var top = root.querySelector('[data-klf2-totop]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

    /* mobile column accordion */
    root.querySelectorAll('.klf2-col > h5').forEach(function (h) {
      h.addEventListener('click', function () {
        if (window.matchMedia('(min-width:681px)').matches) return;
        h.parentElement.classList.toggle('open');
      });
    });
  }

  /* filter + search on .kld table pages (orders, etc.). Pills carry
     data-filter="<value>" (or data-filter-all to show everything) and rows
     carry data-filter-val="<value>"; a [data-kld-search] input matches row
     text. Pill and search are combined (a row shows only if it passes both).
     Bound once per .kld scope. Matching is case-insensitive. */
  function initKldPage(scope) {
    if (!scope || scope.dataset.kldPageBound) return;
    var group = scope.querySelector('.kld-pills[data-kld-filter]');
    var search = scope.querySelector('[data-kld-search]');
    if (!group && !search) return; /* nothing interactive here */
    scope.dataset.kldPageBound = '1';

    var norm = function (s) { return (s || '').trim().toLowerCase(); };
    /* Rows are queried live on every apply() so the filter keeps working after
       a hydration script (e.g. b2b-orders-data.js) replaces the table rows. */
    var apply = function () {
      var active = group ? group.querySelector('.kld-pill.is-active') : null;
      var all = !active || active.hasAttribute('data-filter-all');
      var want = active ? norm(active.getAttribute('data-filter')) : '';
      var q = search ? norm(search.value) : '';
      scope.querySelectorAll('.kld-table__row').forEach(function (r) {
        var pillOk = all || norm(r.getAttribute('data-filter-val')) === want;
        var searchOk = !q || norm(r.textContent).indexOf(q) !== -1;
        r.style.display = (pillOk && searchOk) ? '' : 'none';
      });
    };

    if (group) {
      group.querySelectorAll('.kld-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.kld-pill').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          apply();
        });
      });
    }
    if (search) search.addEventListener('input', apply);
  }

  /* tab groups on .kld pages (e.g. Livrări). A .kld-tabs container holds
     .kld-tab[data-tab] buttons; panels in the same .kld scope are
     [data-tab-panel="<key>"]. Clicking a tab shows its panel only.
     Deep-linkable: /page#<key> or /page?tab=<key> opens that tab on load,
     so other screens can link straight to a tab (e.g. „Adaugă locație” →
     /pages/cont#locations). */
  function initTabs(group) {
    if (!group || group.dataset.kldTabsBound) return;
    group.dataset.kldTabsBound = '1';
    var scope = group.closest('.kld') || document;
    var panels = Array.prototype.slice.call(scope.querySelectorAll('[data-tab-panel]'));
    var tabs = Array.prototype.slice.call(group.querySelectorAll('.kld-tab'));
    function activate(btn) {
      if (!btn) return;
      var key = btn.getAttribute('data-tab');
      tabs.forEach(function (t) { t.classList.toggle('is-active', t === btn); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === key); });
    }
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn); });
    });

    /* open the tab requested by the URL (#<key> or ?tab=<key>), if any */
    function tabForUrl() {
      var key = (window.location.hash || '').replace(/^#/, '');
      if (!key) {
        try { key = new URLSearchParams(window.location.search).get('tab') || ''; } catch (e) {}
      }
      if (!key) return null;
      return tabs.filter(function (t) { return t.getAttribute('data-tab') === key; })[0] || null;
    }
    var initial = tabForUrl();
    if (initial) activate(initial);
    window.addEventListener('hashchange', function () {
      var t = tabForUrl();
      if (t) activate(t);
    });
  }

  /* modal/overlay triggers on .kld pages (e.g. Facturi: Export, XML UBL Hub).
     A [data-kld-modal="<key>"] button opens the [data-kld-modal-panel="<key>"]
     overlay; closing happens on the backdrop, any [data-kld-modal-close], or
     Escape. Bound once per .kld scope. */
  function initKldModals(scope) {
    if (!scope || scope.dataset.kldModalsBound) return;
    var triggers = scope.querySelectorAll('[data-kld-modal]');
    if (!triggers.length) return;
    scope.dataset.kldModalsBound = '1';

    var closeAll = function () {
      scope.querySelectorAll('[data-kld-modal-panel].is-open').forEach(function (p) { p.classList.remove('is-open'); });
      document.documentElement.style.overflow = '';
    };
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = scope.querySelector('[data-kld-modal-panel="' + btn.getAttribute('data-kld-modal') + '"]');
        if (!panel) return;
        closeAll();
        panel.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
      });
    });
    scope.querySelectorAll('[data-kld-modal-panel]').forEach(function (panel) {
      panel.addEventListener('click', function (e) {
        if (e.target === panel || (e.target.closest && e.target.closest('[data-kld-modal-close]'))) closeAll();
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* KPI drill-in detail panels (e.g. Facturi: Sold/Restante/Credit/SPV).
     A [data-kld-drill="<key>"] card hides [data-kld-drill-main] and shows the
     matching [data-kld-drill-panel="<key>"]; a [data-kld-drill-back] button
     returns to the main view. Bound once per .kld scope. */
  function initKldDrill(scope) {
    if (!scope || scope.dataset.kldDrillBound) return;
    var triggers = scope.querySelectorAll('[data-kld-drill]');
    if (!triggers.length) return;
    scope.dataset.kldDrillBound = '1';
    var main = scope.querySelector('[data-kld-drill-main]');
    var panels = Array.prototype.slice.call(scope.querySelectorAll('[data-kld-drill-panel]'));
    var back = function () {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      if (main) main.style.display = '';
    };
    var show = function (key) {
      var panel = scope.querySelector('[data-kld-drill-panel="' + key + '"]');
      if (!panel) return;
      if (main) main.style.display = 'none';
      panels.forEach(function (p) { p.classList.toggle('is-open', p === panel); });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); show(t.getAttribute('data-kld-drill')); });
    });
    scope.querySelectorAll('[data-kld-drill-back]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); back(); });
    });
  }

  /* Pachet builder (Pachete page). A [data-kld-builder] root with
     data-discount="<pct>" holds [data-kld-build-item] checkboxes (each with
     data-price); checking them recomputes subtotal / discount / total into
     [data-kld-build-subtotal|discount|total|count] and toggles the
     [data-kld-build-btn]. Amounts formatted ro-RO. Bound once per root. */
  function initKldBuilder(root) {
    if (!root || root.dataset.kldBuilderBound) return;
    root.dataset.kldBuilderBound = '1';
    var pct = parseFloat(root.getAttribute('data-discount')) || 0;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-kld-build-item]'));
    var fmt = function (n) { return Math.round(n).toLocaleString('ro-RO'); };
    var elCount = root.querySelector('[data-kld-build-count]');
    var elSub = root.querySelector('[data-kld-build-subtotal]');
    var elDisc = root.querySelector('[data-kld-build-discount]');
    var elTot = root.querySelector('[data-kld-build-total]');
    var btn = root.querySelector('[data-kld-build-btn]');
    /* format the static per-item prices on init */
    root.querySelectorAll('[data-kld-build-price]').forEach(function (s) {
      var v = parseFloat(s.getAttribute('data-price'));
      if (!isNaN(v)) s.textContent = fmt(v);
    });
    var recalc = function () {
      var sub = 0, count = 0;
      items.forEach(function (c) {
        var lab = c.closest('.kld-bitem');
        if (c.checked) { count++; sub += parseFloat(c.getAttribute('data-price')) || 0; }
        if (lab) lab.classList.toggle('is-checked', c.checked);
      });
      var disc = Math.round(sub * pct / 100);
      if (elCount) elCount.textContent = count;
      if (elSub) elSub.textContent = fmt(sub);
      if (elDisc) elDisc.textContent = fmt(disc);
      if (elTot) elTot.textContent = fmt(sub - disc);
      if (btn) btn.disabled = count === 0;
    };
    items.forEach(function (c) { c.addEventListener('change', recalc); });
    recalc();

    /* "Adaugă pachetul" → add the checked products' variants to the Shopify cart */
    if (btn) {
      var cartUrl = root.getAttribute('data-cart-url') || kldUrl('cart');
      btn.addEventListener('click', function () {
        var add = [];
        items.forEach(function (c) {
          var vid = c.getAttribute('data-variant');
          if (c.checked && vid) add.push({ id: vid, quantity: 1 });
        });
        if (!add.length) {
          /* nothing selected has a linked Shopify product */
          window.alert('Selectează produse care au un produs Shopify asociat (vezi setările secțiunii).');
          return;
        }
        btn.disabled = true;
        fetch(kldUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: add })
        }).then(function (r) {
          if (!r.ok) { return r.json().then(function (e) { throw e; }); }
          window.location.href = cartUrl;
        }).catch(function () { btn.disabled = false; });
      });
    }
  }

  /* Keep the custom header cart badge in sync with the live cart. Dawn publishes
     PUB_SUB_EVENTS.cartUpdate after any add / quick-add-bulk / cart-drawer edit
     (globals from pubsub.js + constants.js, loaded in the theme head). Bound once. */
  function initCartUpdateBridge() {
    if (initCartUpdateBridge.bound) return;
    initCartUpdateBridge.bound = true;
    kldRefreshBadge(); /* initial: set badge + baseline count, no toast */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { kldRefreshBadge(true); });
    }
  }

  /* Catalog page (b2b-catalog). A [data-kld-catalog] root holds a category
     list (.kld-catalog__cat[data-cat]), filter checkboxes ([data-cat-filter=
     "avizat"|"stock"]), an optional search ([data-cat-search]) and a sort
     select ([data-cat-sort]). Product cards (.kld-catalog__item) carry
     data-cat / data-name / data-price / data-avizat / data-stock / data-i.
     Filtering + sorting is client-side; the count ([data-cat-count]) and empty
     state ([data-cat-empty] + [data-cat-reset]) update live. Qty steppers and
     an AJAX add-to-cart (real products only) are wired here too. Bound once. */
  /* ── Sidebar category tree (snippets/b2b-side-categories) ──────────────────
     Port of the B2C initCategoryActive() (theme.js) without jQuery. A branch
     with children carries a .kld-sidenav__toggle; clicking it opens that branch
     and closes its siblings at the same level (accordion). Liquid already marks
     the current collection's branch as open on render, so no work is needed on
     load — this only wires the interaction. Links are untouched: clicking a
     label navigates, exactly like B2C. */
  function initKldSideNav(root) {
    if (!root || root.dataset.kldSidenavBound) return;
    root.dataset.kldSidenavBound = '1';

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.kld-sidenav__toggle');
      if (!btn || !root.contains(btn)) return;

      var item = btn.closest('.kld-sidenav__item');
      var sub = item && item.querySelector(':scope > .kld-sidenav__sub');
      if (!sub) return;

      var open = sub.hidden;

      /* accordion: collapse the siblings at this level first */
      var parent = item.parentElement;
      if (parent) {
        Array.prototype.forEach.call(parent.children, function (sib) {
          if (sib === item) return;
          var sibSub = sib.querySelector(':scope > .kld-sidenav__sub');
          var sibBtn = sib.querySelector(':scope > .kld-sidenav__row > .kld-sidenav__toggle');
          if (sibSub) sibSub.hidden = true;
          if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          sib.classList.remove('is-open');
        });
      }

      sub.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.classList.toggle('is-open', open);
    });
  }

  /* ── Mobile filter drawer (≤980px) ────────────────────────────────────────
     The catalog sidebar is a plain card on desktop; below 980px the CSS turns
     the same markup into a left off-canvas panel and this wires the trigger.

     Open state is a class on <html>, deliberately NOT on the panel: every
     filter change re-renders the section's innerHTML (initKldFacets), so a
     class held on the panel would be destroyed along with it and the drawer
     could not be controlled across the swap. Applying a filter closes the
     drawer on purpose (see initKldFacets) — <html> is what makes that a
     decision rather than an accident of the re-render. */
  var KLD_FILTERS_OPEN = 'kld-filters-open';

  function kldFiltersClose() {
    document.documentElement.classList.remove(KLD_FILTERS_OPEN);
    document.querySelectorAll('[data-kld-filters-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  function initKldFilterDrawer(root) {
    if (!root || root.dataset.kldDrawerBound) return;
    root.dataset.kldDrawerBound = '1';

    var panel = root.querySelector('[data-kld-filters-panel]');
    var openBtn = root.querySelector('[data-kld-filters-open]');
    if (!panel || !openBtn) return;

    /* A filter change re-renders this markup with aria-expanded="false" baked
       in by Liquid while the drawer is still open — resync on every bind. */
    if (document.documentElement.classList.contains(KLD_FILTERS_OPEN)) {
      openBtn.setAttribute('aria-expanded', 'true');
    }

    var open = function () {
      document.documentElement.classList.add(KLD_FILTERS_OPEN);
      openBtn.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('[data-kld-filters-close]');
      if (first) first.focus();
    };

    openBtn.addEventListener('click', open);

    /* The panel is full-screen on mobile, so there is no "outside" to click —
       closing is the × , Escape, or the apply button in the footer. */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-kld-filters-close]')) {
        kldFiltersClose();
        openBtn.focus();
      }
    });

    /* Keep focus inside the panel while it is open — it covers the page, so
       tabbing out to the products behind it would be a trap of its own. */
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (!document.documentElement.classList.contains(KLD_FILTERS_OPEN)) return;
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    if (!initKldFilterDrawer.globalBound) {
      initKldFilterDrawer.globalBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') kldFiltersClose();
      });
      /* Resizing past the breakpoint leaves the panel back in the grid, so the
         scroll lock and open flag have to go with it. */
      window.addEventListener('resize', function () {
        if (window.innerWidth > 980) kldFiltersClose();
      });
    }
  }

  /* ── Native storefront filters (snippets/b2b-side-filters) ────────────────
     Upgrades the sidebar's plain GET form into an async Section Rendering API
     swap: build the filter.* query string, fetch ?section_id=<id>, replace the
     section's markup and re-run boot() on it. Dawn's facets.js does the same
     thing but is hard-wired to #ProductGridContainer / #product-grid, which the
     .kld markup doesn't have — hence this small local version.

     Without JS the form still submits normally and Shopify filters server-side,
     so the feature degrades rather than breaks. */
  function initKldFacets(form) {
    if (!form || form.dataset.kldFacetsBound) return;
    form.dataset.kldFacetsBound = '1';

    var sectionId = form.getAttribute('data-section-id');
    var section = document.getElementById('shopify-section-' + sectionId);

    /* Visible price inputs are ex-VAT and nameless (see the snippet's VAT note);
       mirror them into the named hidden inputs as VAT-inclusive before serialising. */
    var syncPrice = function () {
      form.querySelectorAll('[data-facet-price]').forEach(function (box) {
        var divisor = parseFloat(box.getAttribute('data-vat-divisor')) || 1;
        box.querySelectorAll('[data-facet-price-input]').forEach(function (input) {
          var which = input.getAttribute('data-facet-price-input');
          var hidden = form.querySelector('[data-facet-price-hidden="' + which + '"]');
          if (!hidden) return;
          var raw = (input.value || '').replace(/\s/g, '').replace(',', '.');
          var n = parseFloat(raw);
          hidden.value = raw === '' || isNaN(n) ? '' : (n * divisor).toFixed(2);
        });
      });
    };

    var queryFrom = function () {
      syncPrice();
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) {
        if (v !== '') params.append(k, v);
      });
      return params.toString();
    };

    var swap = function (query) {
      if (!section) { window.location.search = query; return; }
      section.classList.add('is-loading');

      /* The swap destroys the control that was just used, dumping focus to
         <body>. Remember which input it was so focus can land on its
         replacement — unless the mobile drawer was open, in which case it is
         about to close and focus belongs on the trigger instead. */
      var active = document.activeElement;
      var focusKey = active && active.name ? active.name + '|' + active.value : null;
      var drawerWasOpen = document.documentElement.classList.contains(KLD_FILTERS_OPEN);

      var url = window.location.pathname + '?section_id=' + sectionId + (query ? '&' + query : '');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          /* the endpoint returns the section wrapper too — take its inner markup */
          var fresh = doc.getElementById('shopify-section-' + sectionId) || doc.body;
          section.innerHTML = fresh.innerHTML;
          history.pushState({}, '', window.location.pathname + (query ? '?' + query : ''));
          boot(section);
          if (drawerWasOpen) {
            /* filter applied from the mobile drawer → dismiss it so the results
               are visible straight away, and hand focus to the trigger */
            kldFiltersClose();
            var trigger = section.querySelector('[data-kld-filters-open]');
            if (trigger) trigger.focus();
          } else if (focusKey) {
            var restore = null;
            section.querySelectorAll('input[name]').forEach(function (i) {
              if (!restore && i.name + '|' + i.value === focusKey) restore = i;
            });
            if (restore) restore.focus();
          }
          section.classList.remove('is-loading');
        })
        .catch(function () {
          /* network/parse failure — fall back to a real navigation */
          window.location.search = query;
        });
    };

    /* checkboxes apply immediately; price inputs fire `change` on blur, so they
       apply when the field is left rather than on every keystroke */
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="checkbox"], [data-facet-price-input]')) return;
      swap(queryFrom());
    });
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-facet-price-input]')) return;
      e.preventDefault();
      swap(queryFrom());
    });

    /* "Șterge tot" and the active-value chips are ordinary links */
    form.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-link]');
      if (!link || !form.contains(link)) return;
      e.preventDefault();
      swap(link.search.replace(/^\?/, ''));
    });

    /* show more / show less on long value lists */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-facet-more]');
      if (!btn || !form.contains(btn)) return;
      var group = btn.closest('.kld-facets__group');
      if (!group) return;
      var extras = group.querySelectorAll('.kld-facets__extra');
      var expand = extras.length > 0 && extras[0].hidden;
      extras.forEach(function (li) { li.hidden = !expand; });
      btn.textContent = expand ? btn.getAttribute('data-less-label') : btn.getAttribute('data-more-label');
    });

    /* the form must never submit synchronously once JS is in charge */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      swap(queryFrom());
    });

    /* pushState above rewrites the URL, so Back/Forward must repaint the page */
    if (!initKldFacets.popstateBound) {
      initKldFacets.popstateBound = true;
      window.addEventListener('popstate', function () { window.location.reload(); });
    }
  }

  function initKldCatalog(root) {
    if (!root || root.dataset.kldCatalogBound) return;
    root.dataset.kldCatalogBound = '1';

    var grid = root.querySelector('[data-cat-grid]');
    var cats = Array.prototype.slice.call(root.querySelectorAll('.kld-catalog__cat'));
    var fAviz = root.querySelector('[data-cat-filter="avizat"]');
    var fStock = root.querySelector('[data-cat-filter="stock"]');
    var sortSel = root.querySelector('[data-cat-sort]');
    var search = root.querySelector('[data-cat-search]');
    var countEl = root.querySelector('[data-cat-count]');
    var emptyEl = root.querySelector('[data-cat-empty]');
    var norm = function (s) { return (s || '').trim().toLowerCase(); };
    var num = function (s) { var d = ('' + (s || '')).match(/[0-9]+/g); return d ? parseInt(d.join(''), 10) : 0; };
    var items = function () { return Array.prototype.slice.call(root.querySelectorAll('.kld-catalog__item')); };

    var activeCat = '';
    /* Product types are a taxonomy path ("Dezinfectanți > Mâini & Piele >
       Soluții dezinfectante"), so a category matches a card when it IS the
       card's type or is an ancestor of it. Sidebar categories that carry a full
       type keep matching exactly, as before. */
    var catMatches = function (cardCat, want) {
      var c = norm(cardCat), a = norm(want);
      return c === a || c.indexOf(a + ' > ') === 0;
    };
    var apply = function () {
      var wantAviz = fAviz && fAviz.checked;
      var wantStock = fStock && fStock.checked;
      var q = search ? norm(search.value) : '';
      var shown = 0;
      items().forEach(function (it) {
        var catOk = !activeCat || catMatches(it.getAttribute('data-cat'), activeCat);
        var avizOk = !wantAviz || it.getAttribute('data-avizat') === '1';
        var stockOk = !wantStock || it.getAttribute('data-stock') !== 'out';
        var searchOk = !q || norm(it.textContent).indexOf(q) !== -1;
        var ok = catOk && avizOk && stockOk && searchOk;
        it.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown;
      if (emptyEl) emptyEl.hidden = shown !== 0;
    };

    cats.forEach(function (c) {
      c.addEventListener('click', function () {
        cats.forEach(function (x) { x.classList.remove('is-active'); });
        c.classList.add('is-active');
        activeCat = c.getAttribute('data-cat') || '';
        apply();
      });
    });
    if (fAviz) fAviz.addEventListener('change', apply);
    if (fStock) fStock.addEventListener('change', apply);
    if (search) search.addEventListener('input', apply);

    if (sortSel && grid) {
      sortSel.addEventListener('change', function () {
        var v = sortSel.value;
        items().sort(function (a, b) {
          if (v === 'price-asc') return num(a.getAttribute('data-price')) - num(b.getAttribute('data-price'));
          if (v === 'price-desc') return num(b.getAttribute('data-price')) - num(a.getAttribute('data-price'));
          if (v === 'name') return norm(a.getAttribute('data-name')).localeCompare(norm(b.getAttribute('data-name')));
          return (parseInt(a.getAttribute('data-i'), 10) || 0) - (parseInt(b.getAttribute('data-i'), 10) || 0);
        }).forEach(function (it) { grid.appendChild(it); });
      });
    }

    var reset = root.querySelector('[data-cat-reset]');
    if (reset) reset.addEventListener('click', function () {
      activeCat = '';
      cats.forEach(function (x, i) { x.classList.toggle('is-active', i === 0); });
      if (fAviz) fAviz.checked = false;
      if (fStock) fStock.checked = false;
      if (search) search.value = '';
      apply();
    });

    /* quantity steppers (/pages/catalog b2b-catalog: edit the field; "Adaugă" adds).
       The collection page (b2b-collection) has no [data-kld-qty] / form[data-kld-add]
       — it uses Dawn's native quick-add-bulk — so this is a no-op there. */
    root.querySelectorAll('[data-kld-qty]').forEach(function (q) {
      var val = q.querySelector('[data-qty-val]');
      if (!val) return;
      var get = function () { return Math.max(1, parseInt(val.value, 10) || 1); };
      var dec = q.querySelector('[data-qty-dec]');
      var inc = q.querySelector('[data-qty-inc]');
      if (dec) dec.addEventListener('click', function () { val.value = Math.max(1, get() - 1); });
      if (inc) inc.addEventListener('click', function () { val.value = get() + 1; });
      val.addEventListener('change', function () { val.value = get(); });
    });

    /* AJAX add-to-cart → Dawn cart-drawer. Falls back to native form POST on error. */
    root.querySelectorAll('form[data-kld-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; /* native submit */
        var id = form.querySelector('[name="id"]');
        if (!id || !id.value) return; /* nothing to add — let it submit */
        e.preventDefault();
        var btn = form.querySelector('.kld-pcard__add');
        if (btn && btn.disabled) return;
        var qty = form.querySelector('[name="quantity"]');
        var items = [{ id: id.value, quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1) }];
        var label = btn ? btn.innerHTML : '';
        if (btn) btn.disabled = true;
        var p = kldDawnAdd(items, btn);
        if (p && p.then) {
          p.then(function () {
            if (btn) { btn.disabled = false; btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 1400); }
          }).catch(function () { if (btn) btn.disabled = false; form.submit(); });
        } else if (btn) { btn.disabled = false; }
      });
    });

    apply();
  }

  /* ---- shared cart + toast helpers (Quick Order, Promoții, Resurse) ---- */
  /* Add an array of {id,quantity} line items and reveal Dawn's cart-drawer
     (Quick Order, Promoții, Resurse, Pachete). Falls back to the cart page. */
  function kldAjaxAddItems(items, btn, cartUrl, onSuccess) {
    if (!items || !items.length) return;
    if (btn) btn.disabled = true;
    var p = kldDawnAdd(items, btn, cartUrl);
    if (p && p.then) {
      p.then(function () { if (btn) btn.disabled = false; if (onSuccess) onSuccess(); })
        .catch(function (err) {
          if (btn) btn.disabled = false;
          /* Surface a real add failure (e.g. sold-out / invalid variant) instead
             of failing silently — err is the /cart/add.js error JSON. Translate
             known Shopify server strings (e.g. availability) to Romanian. */
          kldToast(window.kldRoCartMessage(err && (err.description || err.message)) || 'Produsul nu a putut fi adăugat în coș.');
        });
    } else if (btn) { btn.disabled = false; }
  }
  /* lightweight transient toast (prototype st.showToast) */
  function kldToast(msg) {
    if (!msg) return;
    var t = document.createElement('div');
    t.className = 'kld-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-show'); });
    setTimeout(function () { t.classList.remove('is-show'); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300); }, 2600);
  }
  function initKldToasts(scope) {
    scope.querySelectorAll('[data-kld-toast]').forEach(function (btn) {
      if (btn.dataset.kldToastBound) return;
      btn.dataset.kldToastBound = '1';
      btn.addEventListener('click', function () { kldToast(btn.getAttribute('data-kld-toast')); });
    });
  }
  /* generic AJAX add-to-cart for non-catalog forms ([data-kld-add]); the catalog
     page binds its own richer handler, so those are skipped here. */
  function bindAjaxAddForm(form) {
    if (form.dataset.kldAddBound) return;
    form.dataset.kldAddBound = '1';
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; /* native submit */
      var id = form.querySelector('[name="id"]');
      if (!id || !id.value) return;
      e.preventDefault();
      var btn = form.querySelector('[data-kld-add-btn]') || form.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;
      var qty = form.querySelector('[name="quantity"]');
      var items = [{ id: id.value, quantity: Math.max(1, parseInt(qty && qty.value, 10) || 1) }];
      if (btn) { btn.disabled = true; btn.classList.add('is-added'); }
      var p = kldDawnAdd(items, btn);
      if (p && p.then) {
        p.then(function () { if (btn) { btn.disabled = false; setTimeout(function () { btn.classList.remove('is-added'); }, 1400); } })
          .catch(function () { if (btn) btn.disabled = false; form.submit(); });
      } else if (btn) { btn.disabled = false; }
    });
  }
  function initKldCartAdd(scope) {
    scope.querySelectorAll('form[data-kld-add]').forEach(function (f) {
      if (f.closest('[data-kld-catalog]')) return; /* catalog binds its own */
      bindAjaxAddForm(f);
    });
  }

  /* check-circle glyph injected into Quick Order rows (matches b2b-icon) */
  var KLD_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
  /* Matrix Order nudge/alert glyphs (same stroke family as KLD_CHECK). */
  var KLD_MX_UP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  var KLD_MX_ALERT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/></svg>';
  /* mobile Matrix Order card glyphs */
  var KLD_MX_CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
  /* "drills one level deeper" marker in the Matrix Order cascade picker */
  var KLD_MX_CHEV_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

  /* Paginate the storefront /products.json (250 variants/page) into a flat SKU
     catalog [{sku,name,price,vid}] for the Quick Order index — the whole
     published store, so any typed/pasted/CSV code resolves & adds to the real
     cart with no hardcoded blocks. Stops on the first empty/short page; capped
     for safety. Best-effort: any network error resolves with what we have. */
  function loadProductsJson(baseUrl, done) {
    var base = ('' + (baseUrl || '/products.json')).replace(/\/+$/, '');
    if (!/products\.json$/i.test(base)) base += '/products.json';
    if (base.charAt(0) !== '/' && !/^https?:/i.test(base)) base = '/' + base;
    var out = [];
    var MAX_PAGES = 60; /* 60 × 250 = 15k variants safety ceiling */
    function page(n) {
      var url = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'limit=250&page=' + n;
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var prods = d && d.products;
          if (!prods || !prods.length) { done(out); return; }
          prods.forEach(function (p) {
            (p.variants || []).forEach(function (v) {
              var sku = ('' + (v.sku || '')).trim();
              if (!sku) return;
              var nm = p.title + (v.title && v.title !== 'Default Title' ? ' — ' + v.title : '');
              out.push({ sku: sku, name: nm, price: parseFloat(v.price) || 0, vid: v.id, handle: p.handle });
            });
          });
          if (prods.length < 250 || n >= MAX_PAGES) { done(out); return; }
          page(n + 1);
        })
        .catch(function () { done(out); });
    }
    page(1);
  }

  /* Quick Order page (b2b-quick-order). A [data-kld-quick-order] root carries a
     [data-kld-qo-catalog] JSON catalog ([{sku,name,price,vid}]) as a seed +
     discount/tva settings. When data-qo-dynamic="1" the seed is augmented with
     the whole published store via /products.json (dynamic entries override by
     SKU). Three methods (manual SKU rows / paste list / CSV) feed a live
     summary; "add all" AJAX-adds matched rows that have a Shopify variant. */
  function initKldQuickOrder(root) {
    if (!root || root.dataset.kldQoBound) return;
    root.dataset.kldQoBound = '1';
    var cat = [];
    var src = root.querySelector('[data-kld-qo-catalog]');
    if (src) { try { cat = JSON.parse(src.textContent) || []; } catch (e) { cat = []; } }
    var normKey = function (c) { return ('' + (c || '')).trim().toLowerCase(); };
    var byNorm = {};
    var find = function (c) { return byNorm[normKey(c)]; };
    var volPct = parseFloat(root.getAttribute('data-vol-discount')) || 0;
    var tvaPct = parseFloat(root.getAttribute('data-tva')) || 0;
    var cur = root.getAttribute('data-currency') || 'RON';
    var cartUrl = root.getAttribute('data-cart-url') || kldUrl('cart');
    /* 2-decimal RO money (1.234,56) so the summary matches the cart drawer / checkout. */
    var qoNf = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = function (n) { return qoNf.format(Number(n) || 0); };

    /* B2B catalog pricing: when data-qo-ctx="1" (logged-in company + enabled),
       resolve each entered product's CONTRACT price from the company's catalog by
       rendering the b2b-qo-price section in the buyer's session
       (/products/{handle}?section_id=b2b-qo-price). ctxPrice[vid] holds the
       resolved unit price (major units); the summary's discount line then shows
       the REAL saving vs the /products.json list price instead of a flat %. */
    var useCtx = root.getAttribute('data-qo-ctx') === '1';
    var rootUrl = (root.getAttribute('data-qo-root') || '/').replace(/\/+$/, '');
    var ctxPrice = {};   /* vid -> contract unit price (major units) */
    var ctxSeen = {};    /* handle -> 1 once fetched (in-flight or done) */
    var ensureCtxPrice = function (p) {
      if (!useCtx || !window.fetch || !p || !p.handle || ctxSeen[p.handle]) return;
      ctxSeen[p.handle] = 1;
      var url = rootUrl + '/products/' + encodeURIComponent(p.handle) + '?section_id=b2b-qo-price';
      fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (txt) {
          if (!txt) return;
          var node = new DOMParser().parseFromString(txt, 'text/html').querySelector('[data-qo-ctx-prices]');
          if (!node) return;
          var arr; try { arr = JSON.parse(node.textContent); } catch (e) { return; }
          var changed = false;
          arr.forEach(function (v) { if (v && v.id != null) { ctxPrice[v.id] = (Number(v.price) || 0) / 100; changed = true; } });
          if (changed) recalc();
        })
        .catch(function () {});
    };

    var listId = 'kld-qo-skus-' + Math.random().toString(36).slice(2, 8);
    var dl = document.createElement('datalist'); dl.id = listId;
    root.appendChild(dl);

    /* (Re)build the SKU match index + autocomplete datalist from `cat`. The
       match index (byNorm) always stays complete; the datalist is capped so a
       large store doesn't render tens of thousands of <option>s. */
    var DL_MAX = 1000;
    var indexCatalog = function () {
      byNorm = {};
      cat.forEach(function (p) { var k = normKey(p.sku); if (k) byNorm[k] = p; });
      dl.innerHTML = '';
      /* Only SUGGEST orderable products (those with a Shopify variant id). Seed
         blocks without a linked variant (e.g. REP-05) stay in byNorm — so an
         exact-typed code still resolves and shows the amber "indisponibil online"
         hint — but they're not offered in the autocomplete, where a suggestion
         you can't actually add would be misleading. */
      var added = 0;
      for (var i = 0; i < cat.length && added < DL_MAX; i++) {
        if (!cat[i].vid) continue;
        var o = document.createElement('option'); o.value = cat[i].sku; o.textContent = cat[i].name; dl.appendChild(o);
        added++;
      }
    };
    indexCatalog();

    var rowsWrap = root.querySelector('[data-qo-rows]');
    var addBtn = root.querySelector('[data-qo-addall]');
    var set = function (sel, val) { var e = root.querySelector(sel); if (e) e.textContent = val; };

    var makeRow = function (code, q) {
      if (!rowsWrap) return;
      var row = document.createElement('div'); row.className = 'kld-qo__row';
      row.innerHTML =
        '<input class="kld-qo__sku" list="' + listId + '" placeholder="ALC-1L">' +
        '<span class="kld-qo__name">—</span>' +
        '<input class="kld-qo__qty" type="number" min="1" value="' + (q || 1) + '">' +
        '<span class="kld-qo__line">—</span>' +
        '<span class="kld-qo__ok"></span>' +
        '<button type="button" class="kld-qo__del" data-qo-delrow aria-label="Șterge rândul" title="Șterge rândul">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">' +
          '<path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>' +
        '</button>';
      row.querySelector('.kld-qo__sku').value = code || '';
      rowsWrap.appendChild(row);
      return row;
    };

    var discLabel = root.querySelector('[data-qo-disc-label]');
    var discBase = discLabel ? discLabel.textContent : '';
    /* Volume discount from the SAME config the cart and the Matrix grid read,
       so „Discount volum” means the same number on all three. The flat
       `volPct` setting stays as the fallback when no config is published. */
    var QO_CFG = {};
    try { QO_CFG = JSON.parse(root.getAttribute('data-qo-cascade-config') || '{}') || {}; } catch (e) { QO_CFG = {}; }
    var QO_SEG = kldCascadeRules(QO_CFG, root.getAttribute('data-qo-segment') || '');
    var QO_TIERS = (QO_SEG.rules.volume_tiers) || [];
    var qoHasCascade = QO_TIERS.length > 0;
    /* Store prices (products.json + catalog) are VAT-INCLUSIVE (21% baked in, per
       snippets/b2b-novat). The summary shows the store's ex-VAT ("fără TVA")
       convention: ex-VAT = gross / vatDiv, TVA is the difference, and the total
       comes back to the gross price → matches the cart drawer + checkout. */
    var vatDiv = 1 + (tvaPct / 100);
    var recalc = function () {
      var grossSub = 0, grossSave = 0, totQ = 0, valid = 0, rowCount = 0;
      if (rowsWrap) rowsWrap.querySelectorAll('.kld-qo__row').forEach(function (row) {
        rowCount++;
        var skuI = row.querySelector('.kld-qo__sku');
        var nameE = row.querySelector('.kld-qo__name');
        var qtyI = row.querySelector('.kld-qo__qty');
        var lineE = row.querySelector('.kld-qo__line');
        var okE = row.querySelector('.kld-qo__ok');
        var code = skuI.value;
        var p = find(code);
        var q = Math.max(0, parseInt(qtyI.value || '0', 10) || 0);
        /* A row is only truly addable if its catalog match carries a Shopify
           variant id (p.vid). Seed entries (editor blocks) have name+price but no
           vid, so a SKU that matches only a seed — and isn't in /products.json
           (e.g. not published to Online Store) — must NOT show as green/valid, or
           it silently drops out of the cart on "add all". Flag it amber instead. */
        var addable = !!(p && p.vid);
        var matchedNoVid = !!(p && !p.vid);
        skuI.classList.toggle('kld-qo__sku--ok', addable);
        skuI.classList.toggle('kld-qo__sku--warn', matchedNoVid);
        skuI.classList.toggle('kld-qo__sku--bad', !!(code && !p));
        nameE.textContent = p
          ? (matchedNoVid ? p.name + ' · indisponibil online' : p.name)
          : (code ? '✕ SKU negăsit' : '—');
        nameE.classList.toggle('kld-qo__name--ok', addable);
        nameE.classList.toggle('kld-qo__name--warn', matchedNoVid);
        okE.classList.toggle('kld-qo__ok--warn', matchedNoVid);
        if (addable && q > 0) {
          /* List price (from /products.json) drives the subtotal; when B2B catalog
             pricing is on, the company's contract price is the source of truth for
             what they pay, and the difference is the real catalog saving. */
          var listUnit = p.price;
          var contractUnit = (useCtx && ctxPrice[p.vid] != null) ? ctxPrice[p.vid] : listUnit;
          if (useCtx && ctxPrice[p.vid] == null) ensureCtxPrice(p); /* fetch → recalc when it lands */
          var ltGross = listUnit * q;
          /* Line + subtotal use the list price (ex-VAT for display); the catalog
             saving is aggregated into the discount row so "Subtotal − Discount +
             TVA = Total" holds and Total = the company's gross contract price. */
          lineE.textContent = fmt(ltGross / vatDiv) + ' ' + cur;
          okE.innerHTML = KLD_CHECK;
          grossSub += ltGross; totQ += q; valid++;
          grossSave += Math.max(0, (listUnit - contractUnit)) * q;
        }
        else if (matchedNoVid && q > 0) { lineE.textContent = '—'; okE.textContent = '⚠'; }
        else { lineE.textContent = '—'; okE.innerHTML = ''; }
      });
      /* Work in ex-VAT terms. Discount = real catalog saving (B2B, contextual) OR
         the flat fallback %. TVA = 21% of the ex-VAT net; total is VAT-inclusive. */
      var subEx = grossSub / vatDiv;
      /* The catalog saving (list − contract) is NOT a discount: it is already
         inside the contract price. Fold it into the subtotal so the base here is
         the same „preț contractual net” the cart starts from, then apply the
         cascade's volume step on top — that is the number the cart and the grid
         show as PAS 1. */
      var contractEx = subEx - (useCtx ? (grossSave / vatDiv) : 0);
      var volApplied;
      if (qoHasCascade) {
        /* thresholds are NET bani; contractEx is already ex-VAT RON */
        volApplied = kldCascadeBest(contractEx * 100, QO_TIERS, 'min_net');
      } else {
        volApplied = volPct;
      }
      var discEx = contractEx * volApplied / 100;
      var netEx = contractEx - discEx;
      var tva = netEx * tvaPct / 100;
      var total = netEx + tva;
      if (discLabel) discLabel.textContent = volApplied > 0 ? (discBase + ' ' + volApplied + '%') : discBase;
      set('[data-qo-added]', valid + ' din ' + rowCount);
      set('[data-qo-totqty]', totQ);
      set('[data-qo-sub]', fmt(contractEx) + ' ' + cur);
      set('[data-qo-disc]', '−' + fmt(discEx) + ' ' + cur);
      set('[data-qo-tva]', fmt(tva) + ' ' + cur);
      set('[data-qo-total]', fmt(total) + ' ' + cur);
      if (addBtn) addBtn.disabled = valid === 0;
    };

    makeRow('', 1); makeRow('', 1); makeRow('', 1);
    recalc();
    if (rowsWrap) rowsWrap.addEventListener('input', recalc);
    /* Delegated so it also covers rows added later by „Adaugă rând”, paste and
       CSV import. Removing the last row leaves an empty one behind rather than a
       blank panel with no way back except the add button. */
    if (rowsWrap) rowsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qo-delrow]');
      if (!btn) return;
      var row = btn.closest('.kld-qo__row');
      if (!row) return;
      row.remove();
      if (!rowsWrap.querySelector('.kld-qo__row')) makeRow('', 1);
      recalc();
    });
    var addRowBtn = root.querySelector('[data-qo-addrow]');
    if (addRowBtn) addRowBtn.addEventListener('click', function () { makeRow('', 1); recalc(); });

    /* Fully dynamic catalog: pull the whole published store from /products.json
       so any code (typed / pasted / CSV) resolves to a real Shopify variant and
       adds to the cart — the seed blocks/collection stay as an instant fallback.
       Dynamic entries override the seed by SKU; then re-index + recompute so any
       rows already filled in resolve against the fuller catalog. */
    if (root.getAttribute('data-qo-dynamic') === '1') {
      var pUrl = root.getAttribute('data-qo-products-url') || '/products.json';
      loadProductsJson(pUrl, function (dynList) {
        if (!dynList || !dynList.length) return;
        var seen = {};
        dynList.forEach(function (p) { seen[normKey(p.sku)] = 1; });
        cat = cat.filter(function (p) { return !seen[normKey(p.sku)]; }).concat(dynList);
        indexCatalog();
        recalc();
      });
    }

    var tabs = root.querySelectorAll('[data-qo-tab]');
    var panes = root.querySelectorAll('[data-qo-tabpanel]');
    var setTab = function (k) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-qo-tab') === k); });
      panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-qo-tabpanel') === k); });
    };
    tabs.forEach(function (t) { t.addEventListener('click', function () { setTab(t.getAttribute('data-qo-tab')); }); });

    var ta = root.querySelector('[data-qo-paste]');
    var pErr = root.querySelector('[data-qo-perr]');
    var runPaste = function (text) {
      /* Parse "COD, CANTITATE" lines and make a row for EVERY code (recognized or
         not), then let recalc resolve each against the live catalog — same dynamic
         behaviour as the manual tab. Unrecognized codes stay visible as red rows
         to fix (not silently dropped), and because the dynamic /products.json
         loader also calls recalc(), codes pasted before the catalog finishes
         loading auto-resolve (turn green) once it arrives. */
      var raw = ('' + (text || '')).replace(/^﻿/, ''); /* strip UTF-8 BOM from CSV exports */
      var lines = raw.split(/\r?\n+/).map(function (s) { return s.trim(); }).filter(Boolean);
      /* Skip a header row (CSV exports often start with "SKU,Cantitate" / "cod
         SKU, cantitate"): first line matches a header keyword AND its first token
         isn't itself a real product code. */
      var HEADER_RE = /\b(sku|cod|cant|cantitate|qty|quantity|produs|product|nume|name)\b/i;
      if (lines.length && HEADER_RE.test(lines[0]) && !find(lines[0].split(/[\s,;\t]+/)[0])) lines.shift();
      if (pErr) {
        if (!lines.length) { pErr.hidden = false; pErr.textContent = 'Nimic de procesat.'; pErr.className = 'kld-qo__perr kld-qo__perr--bad'; }
      }
      if (!lines.length) return;
      var errs = [];
      if (rowsWrap) rowsWrap.innerHTML = '';
      lines.forEach(function (line) {
        var mt = line.split(/[\s,;\t]+/);
        var code = mt[0];
        var q = parseInt(mt[1] || '1', 10) || 1;
        if (!find(code)) errs.push(code);
        makeRow(code, q);
      });
      setTab('manual'); recalc();
      if (pErr) {
        pErr.hidden = false;
        pErr.textContent = errs.length ? (errs.length + ' coduri nerecunoscute (marcate roșu): ' + errs.join(', ')) : 'Toate codurile au fost recunoscute.';
        pErr.className = 'kld-qo__perr ' + (errs.length ? 'kld-qo__perr--bad' : 'kld-qo__perr--ok');
      }
    };
    var procBtn = root.querySelector('[data-qo-process]');
    if (procBtn && ta) procBtn.addEventListener('click', function () { runPaste(ta.value); });

    var drop = root.querySelector('[data-qo-drop]');
    var file = root.querySelector('[data-qo-file]');
    var readFile = function (f) {
      if (!f || !window.FileReader) return;
      var fr = new FileReader();
      fr.onload = function () { if (ta) ta.value = fr.result; setTab('paste'); runPaste(fr.result); };
      fr.readAsText(f);
    };
    if (file) file.addEventListener('change', function () { readFile(file.files && file.files[0]); });
    if (drop) {
      ['dragover', 'dragenter'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
      ['dragleave', 'dragend'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('is-drag'); }); });
      drop.addEventListener('drop', function (e) { e.preventDefault(); drop.classList.remove('is-drag'); readFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    }
    var csvAlt = root.querySelector('[data-qo-csv-paste]');
    if (csvAlt) csvAlt.addEventListener('click', function () { setTab('paste'); });

    if (addBtn) addBtn.addEventListener('click', function () {
      /* Reconcile the desired quantities against the LIVE cart, then add only the
         delta. /cart/add.js is additive + atomic, so we must not re-send what's
         already in the cart (it would double, and one already-present row hitting
         a quantity rule would atomically reject the whole batch). Reading the real
         cart (/cart.js) instead of local tracking means deleting items from the
         cart correctly re-enables adding them, and duplicate rows for the same
         variant collapse to one desired quantity. */
      var desired = {}, validCount = 0;
      if (rowsWrap) rowsWrap.querySelectorAll('.kld-qo__row').forEach(function (row) {
        var p = find(row.querySelector('.kld-qo__sku').value);
        var q = Math.max(0, parseInt(row.querySelector('.kld-qo__qty').value || '0', 10) || 0);
        if (!(p && p.vid && q > 0)) return;
        validCount++;
        desired[p.vid] = (desired[p.vid] || 0) + q;
      });
      if (!validCount) {
        kldToast('Mod demo — leagă produsele Shopify în setări pentru a adăuga real în coş.');
        return;
      }
      addBtn.disabled = true;
      var buildAndAdd = function (inCart) {
        var items = [];
        Object.keys(desired).forEach(function (vid) {
          var delta = desired[vid] - (inCart[vid] || 0);
          if (delta > 0) items.push({ id: parseInt(vid, 10) || vid, quantity: delta });
        });
        if (!items.length) {
          addBtn.disabled = false;
          kldToast('Toate produsele din listă sunt deja în coș.');
          return;
        }
        kldAjaxAddItems(items, addBtn, cartUrl);
      };
      /* Read current cart quantities per variant; on any failure, fall back to
         adding the full desired quantities (better to add than to silently skip). */
      if (window.fetch) {
        fetch(kldUrl('cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            var inCart = {};
            if (cart && cart.items) cart.items.forEach(function (it) { inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
            buildAndAdd(inCart);
          })
          .catch(function () { buildAndAdd({}); });
      } else {
        buildAndAdd({});
      }
    });
    var saveBtn = root.querySelector('[data-qo-save]');
    if (saveBtn) saveBtn.addEventListener('click', function () { kldToast('Salvat ca listă recurentă'); });
  }

  /* Promoții page (b2b-promotii). Binds the rebate hero simulator: a
     [data-kld-rebate] root with thresholds/volume drives a [data-rebate-extra]
     slider → recomputes projected level/voucher, tracker fill + markers, nudge. */
  function initKldPromo(root) {
    if (!root || root.dataset.kldPromoBound) return;
    root.dataset.kldPromoBound = '1';
    var rebate = root.querySelector('[data-kld-rebate]');
    if (!rebate) return;
    var qvol = parseFloat(rebate.getAttribute('data-qvol')) || 0;
    var max = parseFloat(rebate.getAttribute('data-max')) || 1;
    var cur = rebate.getAttribute('data-currency') || 'RON';
    var tiers = [];
    [['data-t1', 'data-r1'], ['data-t2', 'data-r2']].forEach(function (pair) {
      var t = parseFloat(rebate.getAttribute(pair[0])) || 0;
      var r = parseFloat(rebate.getAttribute(pair[1])) || 0;
      if (t > 0) tiers.push({ t: t, r: r });
    });
    tiers.sort(function (a, b) { return a.t - b.t; });
    var fmt = function (n) { return Math.round(n).toLocaleString('ro-RO'); };
    var slider = rebate.querySelector('[data-rebate-extra]');
    var q = function (s) { return rebate.querySelector(s); };
    var levelOf = function (v) { var p = 0; tiers.forEach(function (x) { if (v >= x.t) p = x.r; }); return p; };
    var nextOf = function (v) { for (var i = 0; i < tiers.length; i++) { if (v < tiers[i].t) return tiers[i]; } return null; };

    rebate.querySelectorAll('[data-rebate-marker]').forEach(function (mk) {
      var t = parseFloat(mk.getAttribute('data-threshold')) || 0;
      var r = parseFloat(mk.getAttribute('data-pct')) || 0;
      var lab = mk.querySelector('[data-rebate-mlabel]');
      if (lab) lab.textContent = '−' + r + '% · ' + fmt(t);
    });

    var recompute = function () {
      var extra = slider ? (parseInt(slider.value, 10) || 0) : 0;
      var proj = qvol + extra;
      var lvl = levelOf(proj);
      var voucher = proj * lvl / 100;
      var nx = nextOf(proj);
      var setT = function (s, v) { var e = q(s); if (e) e.textContent = v; };
      setT('[data-rebate-vol]', fmt(proj));
      setT('[data-rebate-level]', lvl ? '−' + lvl + '%' : '—');
      setT('[data-rebate-voucher]', fmt(voucher));
      setT('[data-rebate-extra-label]', '+' + fmt(extra) + ' ' + cur);
      setT('[data-rebate-proj-level]', lvl ? '−' + lvl + '%' : '—');
      setT('[data-rebate-proj-voucher]', fmt(voucher));
      var lv = q('[data-rebate-level]'); if (lv) lv.classList.toggle('is-on', lvl > 0);
      var fill = q('[data-rebate-fill]'); if (fill) fill.style.width = Math.min(100, proj / max * 100) + '%';
      rebate.querySelectorAll('[data-rebate-marker]').forEach(function (mk) {
        var t = parseFloat(mk.getAttribute('data-threshold')) || 0;
        mk.classList.toggle('is-passed', proj >= t);
      });
      var nudge = q('[data-rebate-nudge]');
      if (nudge) {
        if (nx) { nudge.className = 'kld-rh__nudge'; nudge.innerHTML = 'Mai ai <strong>' + fmt(nx.t - proj) + ' ' + cur + '</strong> până la pragul <strong>−' + nx.r + '%</strong>.'; }
        else { nudge.className = 'kld-rh__nudge is-max'; nudge.innerHTML = 'Ai atins pragul maxim de rebate. 🎯'; }
      }
    };
    if (slider) slider.addEventListener('input', recompute);
    recompute();
  }

  /* Resurse page (b2b-resurse). A [data-kld-resurse] root drives: accordion
     zones, the dozaj calculator (product + area/freq sliders → consum/packs/
     value, "add to simulator" basket), and the cascaded-discount simulator
     (account_type configs + cart/cats/qvol sliders + ramburs/Bragadiru). */
  function initKldResurse(root) {
    if (!root || root.dataset.kldResBound) return;
    root.dataset.kldResBound = '1';
    var cur = root.getAttribute('data-currency') || 'RON';
    var cartUrl = root.getAttribute('data-cart-url') || kldUrl('cart');
    var fmt = function (n) { return Math.round(n).toLocaleString('ro-RO'); };
    var parseJSON = function (sel) { var s = root.querySelector(sel); if (!s) return []; try { return JSON.parse(s.textContent) || []; } catch (e) { return []; } };
    var DOZ = parseJSON('[data-res-dozaj]');
    var ACC = parseJSON('[data-res-accounts]');
    var accByKey = {}; ACC.forEach(function (a) { accByKey[a.key] = a; });

    root.querySelectorAll('[data-res-toggle]').forEach(function (head) {
      head.addEventListener('click', function () { var z = head.closest('[data-res-zone]'); if (z) z.classList.toggle('is-open'); });
    });

    /* deep link: /pages/resurse-b2b#<zone id> opens that zone and scrolls to it
       (the native anchor jump lands before we expand, so re-scroll ourselves) */
    function openZoneForHash(smooth) {
      var id = (window.location.hash || '').replace(/^#/, '');
      if (!id) return;
      var zone = root.querySelector('[data-res-zone]#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
      if (!zone) return;
      zone.classList.add('is-open');
      setTimeout(function () {
        zone.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      }, 60);
    }
    openZoneForHash(false);
    window.addEventListener('hashchange', function () { openZoneForHash(true); });

    var simVolTier = function (s) { if (s >= 4000) return .20; if (s >= 2000) return .15; if (s >= 1000) return .10; return 0; };
    var simSortim = function (catn, sortim) { var c = Math.min(catn, 4); var k = c >= 4 ? 4 : c; return sortim[k] || sortim['' + k] || 0; };

    var pi = 0, area = 120, freq = 20;
    var basket = [];
    var curKey = (ACC[0] && ACC[0].key) || 'standard';
    var cartS = 3500, catS = 2, qS = 34000, ramburs = false, brag = false;

    /* dozaj */
    var selP = root.querySelector('[data-dz-product]');
    var areaR = root.querySelector('[data-dz-area]');
    var freqR = root.querySelector('[data-dz-freq]');
    var dozajState = function () {
      var dp = DOZ[pi] || { d: 0, price: 0, pack: 1, name: '', cat: '' };
      var monthlyL = (area * dp.d * freq) / 1000;
      var packs = Math.max(1, Math.ceil(monthlyL / (dp.pack || 1)));
      return { dp: dp, monthlyL: monthlyL, packs: packs, dozVal: packs * dp.price };
    };
    var renderDozaj = function () {
      var s = dozajState();
      var setT = function (sel, v) { var e = root.querySelector(sel); if (e) e.textContent = v; };
      setT('[data-dz-area-val]', area + ' mp');
      setT('[data-dz-freq-val]', freq);
      setT('[data-dz-dose]', s.dp.d + ' ml/mp');
      setT('[data-dz-monthly]', s.monthlyL.toFixed(1) + ' L');
      setT('[data-dz-packs]', s.packs + ' × ' + s.dp.pack + 'L');
      setT('[data-dz-value]', fmt(s.dozVal) + ' ' + cur);
    };
    if (selP) selP.addEventListener('change', function () { pi = parseInt(selP.value, 10) || 0; renderDozaj(); });
    if (areaR) areaR.addEventListener('input', function () { area = parseInt(areaR.value, 10) || 0; renderDozaj(); });
    if (freqR) freqR.addEventListener('input', function () { freq = parseInt(freqR.value, 10) || 0; renderDozaj(); });
    renderDozaj();

    var renderSim;
    var addSim = root.querySelector('[data-dz-add-sim]');
    if (addSim) addSim.addEventListener('click', function () {
      var s = dozajState();
      basket.push({ name: s.dp.name, cat: s.dp.cat, value: s.dozVal, packs: s.packs, pack: s.dp.pack });
      var z2 = root.querySelector('[data-res-sim]'); if (z2) z2.classList.add('is-open');
      renderSim();
      setTimeout(function () { if (z2) z2.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    });
    var addCart = root.querySelector('[data-dz-add-cart]');
    if (addCart) addCart.addEventListener('click', function () {
      var s = dozajState();
      if (s.dp.vid) kldAjaxAddItems([{ id: s.dp.vid, quantity: s.packs }], addCart, cartUrl);
      else kldToast('Mod demo — leagă un produs Shopify în setări.');
    });

    /* simulator */
    var segs = root.querySelectorAll('[data-sim-seg]');
    var cartR = root.querySelector('[data-sim-cart]');
    var catsR = root.querySelector('[data-sim-cats]');
    var qvolR = root.querySelector('[data-sim-qvol]');
    var rambursC = root.querySelector('[data-sim-ramburs]');
    var bragC = root.querySelector('[data-sim-brag]');
    segs.forEach(function (b) { b.addEventListener('click', function () { curKey = b.getAttribute('data-key'); segs.forEach(function (x) { x.classList.toggle('is-active', x === b); }); renderSim(); }); });
    if (cartR) cartR.addEventListener('input', function () { cartS = parseInt(cartR.value, 10) || 0; renderSim(); });
    if (catsR) catsR.addEventListener('input', function () { catS = parseInt(catsR.value, 10) || 0; renderSim(); });
    if (qvolR) qvolR.addEventListener('input', function () { qS = parseInt(qvolR.value, 10) || 0; renderSim(); });
    if (rambursC) rambursC.addEventListener('change', function () { ramburs = rambursC.checked; renderSim(); });
    if (bragC) bragC.addEventListener('change', function () { brag = bragC.checked; renderSim(); });

    renderSim = function () {
      var cfg = accByKey[curKey] || ACC[0]; if (!cfg) return;
      var useBasket = basket.length > 0;
      var basketTotal = basket.reduce(function (a, b) { return a + b.value; }, 0);
      var seen = {}; basket.forEach(function (p) { seen[p.cat] = 1; });
      var basketCats = Object.keys(seen).length;
      var cart = useBasket ? basketTotal : cartS;
      var cats = useBasket ? Math.max(1, basketCats) : catS;
      var finAllowed = !!cfg.fin, bragAllowed = !!cfg.brag;
      var blocked = cfg.threshold > 0 && cart < cfg.threshold;
      var dBase = cfg.base != null ? cfg.base : 0;
      var dVol = cfg.vol ? simVolTier(cart) : 0;
      var dSort = cart > 0 ? simSortim(cats, cfg.sortim) : 0;
      var dFin = 0; if (finAllowed) { if (ramburs) dFin += .03; if (brag && bragAllowed) dFin += .02; }
      var setT = function (sel, v) { var e = root.querySelector(sel); if (e) e.textContent = v; };

      var bWrap = root.querySelector('[data-sim-basket-wrap]');
      var bInfo = root.querySelector('[data-sim-basket-info]');
      var bList = root.querySelector('[data-sim-basket]');
      if (bWrap) bWrap.hidden = !useBasket;
      if (useBasket && bInfo) bInfo.textContent = 'Coş calculat · ' + basket.length + ' produse · ' + basketCats + ' categorii · ' + fmt(basketTotal) + ' ' + cur;
      if (bList) {
        bList.innerHTML = '';
        basket.forEach(function (p, i) {
          var row = document.createElement('div'); row.className = 'kld-sim__bitem';
          row.innerHTML = '<span class="kld-sim__bname"><b>' + p.name + '</b><small>' + p.cat + ' · ' + p.packs + '×' + p.pack + 'L</small></span><span class="kld-sim__bval">' + fmt(p.value) + ' ' + cur + '</span><button type="button" class="kld-sim__brm" aria-label="Elimină">×</button>';
          row.querySelector('.kld-sim__brm').addEventListener('click', function () { basket.splice(i, 1); renderSim(); });
          bList.appendChild(row);
        });
      }

      if (cartR) cartR.disabled = useBasket;
      if (catsR) catsR.disabled = useBasket;
      var cartWrap = root.querySelector('[data-sim-cart-wrap]'); if (cartWrap) cartWrap.classList.toggle('is-disabled', useBasket);
      var catsWrap = root.querySelector('[data-sim-cats-wrap]'); if (catsWrap) catsWrap.classList.toggle('is-disabled', useBasket);
      if (cartR && useBasket) cartR.value = Math.min(20000, cart);
      if (catsR && useBasket) catsR.value = Math.min(6, cats);

      if (rambursC) rambursC.disabled = !finAllowed;
      if (bragC) bragC.disabled = !bragAllowed;
      var rLab = rambursC && rambursC.closest('.kld-sim__check'); if (rLab) rLab.classList.toggle('is-disabled', !finAllowed);
      var bLab = bragC && bragC.closest('.kld-sim__check'); if (bLab) bLab.classList.toggle('is-disabled', !bragAllowed);

      setT('[data-sim-cart-val]', fmt(cart) + ' ' + cur + (useBasket ? ' (din produse)' : ''));
      setT('[data-sim-cats-val]', cats + (useBasket ? ' (din produse)' : ''));
      setT('[data-sim-qvol-val]', fmt(qS) + ' ' + cur);
      setT('[data-sim-cfg-label]', cfg.label || '');

      var rows = [{ lab: 'Subtotal contractual', sub: 'prețul tău de catalog', val: cart, base: true }];
      var running = cart;
      var step = function (lab, sub, d) { if (d <= 0) return; running = running * (1 - d); rows.push({ lab: lab, sub: sub, pct: d, cut: true }); };
      if (cfg.base != null) step('Bază contractuală', 'discount fix de tier', dBase);
      if (cfg.vol) step('Discount volum', 'pe pragul valorii coşului', dVol);
      step('Sortimentație', cats + ' categorii distincte', dSort);
      if (dFin > 0) step('Financiar / logistic', 'ramburs / ridicare', dFin);
      var eff = cart > 0 ? 1 - running / cart : 0;
      var saved = cart - running;

      var rowsEl = root.querySelector('[data-sim-rows]');
      if (rowsEl) {
        if (blocked) {
          rowsEl.innerHTML = '<div class="kld-cascrow kld-cascrow--blocked"><span class="kld-cascrow__lab">Comandă sub pragul minim</span><span class="kld-cascrow__blk">BLOCAT</span></div>';
        } else {
          rowsEl.innerHTML = '';
          rows.forEach(function (r) {
            var d = document.createElement('div'); d.className = 'kld-cascrow';
            var w = r.cut ? Math.min(100, r.pct * 260) : 100;
            d.innerHTML = '<div class="kld-cascrow__lab">' + r.lab + '<small>' + r.sub + '</small></div>' +
              '<div class="kld-cascrow__bar"><div class="kld-cascrow__fill' + (r.cut ? ' kld-cascrow__fill--cut' : '') + '" style="width:' + w + '%"></div></div>' +
              '<div class="kld-cascrow__val' + (r.cut ? ' kld-cascrow__val--cut' : '') + '">' + (r.cut ? '−' + Math.round(r.pct * 100) + '%' : fmt(r.val)) + '</div>';
            rowsEl.appendChild(d);
          });
        }
      }

      setT('[data-sim-price]', blocked ? '—' : fmt(running) + ' ' + cur);
      var psub = root.querySelector('[data-sim-price-sub]');
      if (psub) psub.textContent = blocked ? 'adaugă produse pentru a debloca checkout-ul' : 'economiseşti ' + fmt(saved) + ' ' + cur + ' · −' + (eff * 100).toFixed(1) + '%';

      var earned = 0, nextT = null;
      if (cfg.rebate && cfg.rebate.length) {
        for (var i = 0; i < cfg.rebate.length; i++) { var t = cfg.rebate[i][0], p = cfg.rebate[i][1]; if (qS >= t) earned = p; else { nextT = [t, p]; break; } }
      }
      var reb = root.querySelector('[data-sim-rebate]');
      if (reb) {
        var html, on = false;
        if (!cfg.rebate || !cfg.rebate.length) html = '⌛ <b>Rebate trimestrial</b>: disponibil pentru conturile Professional Strategic şi Distribuitor. Contul curent nu are tier de rebate.';
        else if (earned > 0) { on = true; html = '✓ <b>Rebate trimestrial atins: ' + Math.round(earned * 100) + '%</b> — voucher retroactiv de ≈ <b>' + fmt(qS * earned) + ' ' + cur + '</b>, valabil 60 zile, peste discountul de mai sus.'; }
        else html = '⌛ <b>Rebate trimestrial</b>: încă <b>' + fmt(nextT[0] - qS) + ' ' + cur + '</b> până la pragul de <b>' + Math.round(nextT[1] * 100) + '%</b> (target ' + fmt(nextT[0]) + ' ' + cur + '/trim).';
        reb.className = 'kld-sim__rebate ' + (on ? 'is-on' : 'is-off');
        reb.innerHTML = html;
      }

      var nudges = [];
      if (blocked) nudges.push([false, '<b>Prag minim:</b> mai adaugă <b>' + fmt(cfg.threshold - cart) + ' ' + cur + '</b> pentru a atinge ' + fmt(cfg.threshold) + ' ' + cur + ' şi a debloca comanda.']);
      else if (cfg.vol) {
        if (cart < 1000) nudges.push([false, '<b>Volum:</b> mai adaugă <b>' + fmt(1000 - cart) + ' ' + cur + '</b> pentru prima treaptă (−10%).']);
        else if (cart < 2000) nudges.push([false, '<b>Volum:</b> mai adaugă <b>' + fmt(2000 - cart) + ' ' + cur + '</b> pentru −15%.']);
        else if (cart < 4000) nudges.push([false, '<b>Volum:</b> mai adaugă <b>' + fmt(4000 - cart) + ' ' + cur + '</b> pentru −20% (pragul maxim).']);
        else nudges.push([true, '<b>Volum:</b> pragul maxim atins (−20%).']);
      } else nudges.push([true, '<b>Bază contractuală fixă:</b> ' + Math.round((cfg.base || 0) * 100) + '% din primul leu, indiferent de volum.']);
      if (cart > 0) {
        if (cats < 4) { var c = simSortim(cats, cfg.sortim), n = simSortim(cats + 1, cfg.sortim); nudges.push([false, '<b>Sortimentație:</b> mai adaugă <b>1 categorie</b> → bonus creşte de la ' + Math.round(c * 100) + '% la ' + Math.round(n * 100) + '%.']); }
        else nudges.push([true, '<b>Sortimentație:</b> bonus maxim atins (4+ categorii).']);
      }
      var nud = root.querySelector('[data-sim-nudges]');
      if (nud) {
        nud.innerHTML = '';
        nudges.forEach(function (nn) {
          var d = document.createElement('div'); d.className = 'kld-sim__nudge' + (nn[0] ? ' is-done' : '');
          d.innerHTML = '<span class="kld-sim__nudge-ic">' + (nn[0] ? '✓' : '+') + '</span><div>' + nn[1] + '</div>';
          nud.appendChild(d);
        });
      }
    };

    var resetBtn = root.querySelector('[data-sim-basket-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () { basket = []; renderSim(); });
    renderSim();
  }

  /* Matrix Order page (b2b-matrix-order). A [data-kld-matrix-order] root carries
     a [data-kld-mx-catalog] JSON catalog

       [{ id, name, cols:[…packaging…], subs:[…subcategory…],
          products:[{ n, sub, sc, v:{ "<col>": [sku, price, moq, stock] } }] }]

     plus the discount thresholds as data-attributes. The category × packaging
     grid is rendered here; a sku→qty map is the single source of truth behind
     the line totals, the MOQ/stock validation card, the discount cascade and
     the summary. The catalog itself is STATIC (ported from the prototype) — the
     only real part is the cart hand-off: with data-mx-dynamic="1" the SKUs are
     matched against the published store via /products.json, so "add all" does a
     real AJAX /cart/add.js; codes with no Shopify variant are reported. */
  /* Builds the Matrix Order catalog from the real store instead of the static
     prototype JSON. Walks `/collections/all?section_id=b2b-mx-catalog&page=N`
     (see sections/b2b-mx-catalog.liquid) — rendered in the logged-in company's
     session, so the prices are that company's CATALOG prices, which
     /products.json cannot give.

     Shape out is exactly what initKldMatrixOrder already consumes:
       [{ id, name, cols, subs, products:[{ n, sub, sc, v:{ col:[sku,price,moq,stock] } }] }]

     Packaging option values are folded onto canonical columns through the
     [data-kld-mx-map] table ("5l", "5 litri", "5 L" → "5 L"), because the same
     size is spelled several ways in the catalog. Bax variants get their own
     column ("5 L · bax"): in this store a bax is a SEPARATE variant with its
     own SKU, price and stock, so it cannot share a cell with the loose unit.
     Per decision, the ordering increment is 1 everywhere → moq is always 1. */
  /* ---- cascade helpers, shared by the Matrix grid and the Quick Order summary
     ----------------------------------------------------------------------
     Ported from D:\klintensiv\klintensiv-cascade,
     extensions/cascade-discount/src/cascade.ts. They live at module scope so the
     two summaries cannot drift from each other, or from the Shopify Function. */
  function kldCascadeSegment(cfg, raw) {
    var fallback = (cfg && cfg.default_segment) || 'standard';
    if (!raw) return fallback;
    var n = String(raw).toLowerCase().trim()
      .replace(/[ăâà]/g, 'a').replace(/[îí]/g, 'i')
      .replace(/[șş]/g, 's').replace(/[țţ]/g, 't');
    if (n.indexOf('distrib') === 0) return 'distribuitor';
    if (n.indexOf('prof') === 0) return 'professional';
    if (n.indexOf('stand') === 0) return 'standard';
    return fallback;
  }
  /* Shopify reports VAT-inclusive money here; every threshold in the policy is NET. */
  function kldCascadeNet(value, cfg) {
    var vat = cfg && cfg.vat;
    if (!vat || !vat.prices_include_vat) return value;
    var rate = vat.rate || 0;
    return rate > 0 ? value / (1 + rate / 100) : value;
  }
  /* highest rule whose threshold is met wins */
  function kldCascadeBest(value, rules, key) {
    var pct = 0, best = -1;
    (rules || []).forEach(function (r) {
      if (value >= r[key] && r[key] > best) { best = r[key]; pct = r.pct || 0; }
    });
    return pct;
  }
  function kldCascadeRules(cfg, rawSegment) {
    var seg = kldCascadeSegment(cfg, rawSegment);
    return {
      segment: seg,
      rules: ((cfg && cfg.segments) || {})[seg] || { volume_tiers: [], assortment: [], modifiers: {} }
    };
  }

  var KLD_MX_UNIT_RE = /^(bucata|buc|pachet|rola|role|set|seturi|default title|default|title)$/i;
  var KLD_MX_BAX_RE = /^bax$/i;
  /* a cell key of the form "#<variantId>" stands in for a variant with no SKU:
     usable everywhere internally, but never shown or searched as a code */
  var KLD_MX_SYNTH_RE = /^#\d+$/;
  function kldMxIsSynthSku(k) { return KLD_MX_SYNTH_RE.test('' + (k || '')); }

  function kldMxFetchCatalog(url, onDone) {
    var items = [], page = 1, MAX = 12;
    var step = function () {
      fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-mx-catalog-page]');
          if (!el) throw 0;
          var d = JSON.parse(el.textContent);
          items = items.concat(d.items || []);
          if (d.more && page < MAX) { page++; step(); } else onDone(items);
        })
        .catch(function () { onDone(items); });
    };
    step();
  }

  /* Places a product on the category tree by the collections it sits in, so the
     grid's tabs and chips are the same "Categorii" branches the collection
     sidebar shows — and no product has to be re-tagged for the grid. */
  /* Menu hrefs arrive percent-encoded (/collections/dezinfectan%C8%9Bi) while
     product.collections yields the raw handle (dezinfectanți), so every handle
     is normalised on both sides before comparing. */
  function kldMxHandle(h) {
    if (!h) return '';
    var s = String(h);
    if (s.indexOf('%') >= 0) { try { s = decodeURIComponent(s); } catch (e) { /* keep raw */ } }
    return s.toLowerCase();
  }

  /* Walks all THREE menu levels — categorie › subcategorie › tip de produs —
     because the cascade picker navigates them one by one. Depth is whatever the
     menu offers: a product only in a level-2 collection places with an empty
     `grp`, one only in the level-1 collection with an empty `sub` too, and the
     picker skips the columns that stay empty. */
  function kldMxPlace(tree, handles) {
    var has = {};
    (handles || []).forEach(function (h) { has[kldMxHandle(h)] = 1; });
    var inIt = function (h) { return h && has[kldMxHandle(h)]; };
    for (var i = 0; i < tree.length; i++) {
      var c = tree[i], subs = c.s || [];
      for (var j = 0; j < subs.length; j++) {
        var s = subs[j];
        /* deepest match wins, so a product in both "Suprafețe" and one of its
           tipuri lands on the tip rather than stopping one level short */
        var grps = s.g || [];
        for (var k = 0; k < grps.length; k++) {
          if (inIt(grps[k].h)) return { cat: c.t, sub: s.t, grp: grps[k].t };
        }
        /* legacy 2-level tree: `h` was the array of level-2 + level-3 handles */
        var hs = s.h && s.h.push ? s.h : [s.h];
        for (var m = 0; m < hs.length; m++) {
          if (inIt(hs[m])) return { cat: c.t, sub: s.t, grp: '' };
        }
      }
      if (inIt(c.h)) return { cat: c.t, sub: '', grp: '' };
    }
    return null;
  }

  function kldMxBuild(items, map, opts) {
    /* Empty label = no catch-all tab: products the tree can't place are left out
       of the grid rather than piling into a mixed bag. */
    var uncat = (opts && opts.uncat) || '';
    var tree = (opts && opts.tree) || [];
    var cats = {}, order = [];
    /* `subs` is a list of { n, g:[…tip de produs…] } — the two levels under the
       category that the cascade picker walks. */
    var catOf = function (name) {
      if (!cats[name]) {
        cats[name] = { id: 'c' + order.length, name: name, cols: [], colSeen: {}, subs: [], subSeen: {}, products: [] };
        order.push(name);
      }
      return cats[name];
    };
    var subOf = function (C, name) {
      if (!C.subSeen[name]) { C.subSeen[name] = { n: name, g: [], gSeen: {} }; C.subs.push(C.subSeen[name]); }
      return C.subSeen[name];
    };
    /* Keep the categories in menu order, not in the order products happen to
       arrive — and list the „Categorie suplimentară" ones (c.x) LAST, however
       early they sit in the tree. Their position there is placement priority
       (kldMxPlace takes the first match, so Pachete claims its bundles before
       Curățenie can), which is a different question from where they belong in
       the picker: at the end, after the real catalog branches. */
    tree.forEach(function (c) { if (!c.x) catOf(c.t); });
    tree.forEach(function (c) { if (c.x) catOf(c.t); });

    items.forEach(function (p) {
      /* With a menu tree in play, anything it does not place goes to the catch-all
         tab — or nowhere, when no catch-all label is set. Falling back to the
         cascade metafield here would spawn a second, near-identical tab
         ("Dezinfectanti" beside the menu's "Dezinfectanți"). */
      var place = kldMxPlace(tree, p.cl);
      if (!place) {
        if (tree.length) {
          if (!uncat) return;                        /* unplaced → skip the product */
          place = { cat: uncat, sub: '', grp: '' };
        } else {
          /* no tree at all (menu missing) — keep the old metafield grouping */
          place = { cat: (p.c && String(p.c).trim()) || uncat || 'Diverse', sub: '', grp: '' };
        }
      }
      var C = catOf(place.cat);
      var sc = place.sub || '', gc = place.grp || '';
      if (sc) {
        var S = subOf(C, sc);
        if (gc && !S.gSeen[gc]) { S.gSeen[gc] = 1; S.g.push(gc); }
      }

      /* One cell per packaging size, holding BOTH variants of it: the loose unit
         and its bax twin. In this store a bax is a separate variant with its own
         SKU, price and stock, so the BAX/BUC switch picks which variant the cell
         orders — it is not a unit conversion. Pairing them here is what keeps the
         grid narrow: as separate columns, Consumabile alone spanned 53. */
      var v = {};
      (p.v || []).forEach(function (vr) {
        /* SKU is only a label — the variant id is what the cart needs. Whole
           categories (Controlul igienei) carry no SKU at all in this store, so
           key such variants by id instead of dropping them; kldMxIsSynthSku
           recognises those keys so the UI can hide them. */
        var key = vr.s || (vr.i ? '#' + vr.i : '');
        if (!key) return;
        var col = null, isBax = false;
        (vr.o || []).forEach(function (ov) {
          var s = String(ov).trim();
          if (KLD_MX_BAX_RE.test(s)) { isBax = true; return; }
          if (KLD_MX_UNIT_RE.test(s)) return;
          if (map[s] && !col) col = map[s];
        });
        if (!col) col = (opts && opts.plainCol) || 'Standard';
        var price = (Number(vr.p) || 0) / 100, stock = Number(vr.q) || 0;
        var cell = v[col] || (v[col] = [null, 0, 1, 0]);
        if (isBax) {
          if (cell[4]) return;                                /* first bax wins */
          cell[4] = key; cell[5] = price; cell[6] = stock; cell[9] = vr.i || 0;
        } else {
          if (cell[0]) return;                                /* first unit wins */
          cell[0] = key; cell[1] = price; cell[3] = stock; cell[8] = vr.i || 0;
        }
        if (!C.colSeen[col]) { C.colSeen[col] = 1; C.cols.push(col); }
      });
      /* a bax with no loose twin still has to be orderable — promote it */
      Object.keys(v).forEach(function (col) {
        var c = v[col];
        if (!c[0] && c[4]) { c[0] = c[4]; c[1] = c[5]; c[3] = c[6]; c[8] = c[9]; c[4] = null; c[9] = 0; c[7] = 1; }
      });
      if (!Object.keys(v).length) return;

      /* `cc` is the CASCADE category (custom.cascade_discount_category), which
         is NOT the grid tab: tabs come from the catalog menu. The discount
         function counts distinct cc values, so the preview must too. */
      C.products.push({ n: p.t, sub: p.y || '', sc: sc, gc: gc, cc: (p.c || '').trim(), v: v });
    });

    var numOf = function (s) { var m = String(s).match(/^([\d,.]+)/); return m ? parseFloat(m[1].replace(',', '.')) : 1e9; };
    return order.map(function (name) {
      var C = cats[name];
      C.cols.sort(function (a, b) {
        var ua = a.replace(/^[\d,.]+\s*/, ''), ub = b.replace(/^[\d,.]+\s*/, '');
        if (ua !== ub) return ua.localeCompare(ub, 'ro');
        return numOf(a) - numOf(b);
      });
      /* both lower levels follow the menu, with anything unplaced trailing */
      var mt = null;
      tree.forEach(function (c) { if (c.t === name) mt = c; });
      if (mt) {
        var menuSubs = mt.s || [];
        var want = menuSubs.map(function (s) { return s.t; });
        C.subs.sort(function (a, b) {
          var ia = want.indexOf(a.n), ib = want.indexOf(b.n);
          return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
        });
        C.subs.forEach(function (s) {
          var ms = null;
          menuSubs.forEach(function (x) { if (x.t === s.n) ms = x; });
          if (!ms) return;
          var wantG = (ms.g || []).map(function (g) { return g.t; });
          s.g.sort(function (a, b) {
            var ia = wantG.indexOf(a), ib = wantG.indexOf(b);
            return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
          });
        });
      }
      C.subs.forEach(function (s) { delete s.gSeen; });
      delete C.colSeen; delete C.subSeen;
      return C;
    }).filter(function (c) { return c.products.length && c.cols.length; });
  }

  function initKldMatrixOrder(root) {
    if (!root || root.dataset.kldMxBound) return;

    /* Dynamic source: load the real catalog first, then re-enter with it.
       init runs more than once per page (DOMContentLoaded + section load), so a
       second call arriving mid-fetch must WAIT here. Letting it fall through
       would bind the section against the still-empty catalog and set
       kldMxBound, which then blocks the re-entry that carries the real data. */
    var srcUrl = root.getAttribute('data-mx-catalog-url');
    if (srcUrl) {
      if (root.dataset.kldMxLoading) return;
      root.dataset.kldMxLoading = '1';
      var mapEl = root.querySelector('[data-kld-mx-map]');
      var map = {};
      if (mapEl) { try { map = JSON.parse(mapEl.textContent) || {}; } catch (e) { map = {}; } }
      if (map.mapping) map = map.mapping;
      var treeEl = root.querySelector('[data-kld-mx-tree]');
      var tree = [];
      if (treeEl) { try { tree = JSON.parse(treeEl.textContent) || []; } catch (e) { tree = []; } }
      kldMxFetchCatalog(srcUrl, function (items) {
        var built = items.length ? kldMxBuild(items, map, {
          tree: tree,
          uncat: root.getAttribute('data-mx-uncat') || '',
          plainCol: root.getAttribute('data-mx-plain-col') || 'Standard'
        }) : [];
        var holder = root.querySelector('[data-kld-mx-catalog]');
        if (built.length && holder) holder.textContent = JSON.stringify(built);
        root.removeAttribute('data-mx-catalog-url');   /* second pass reads the JSON */
        root.removeAttribute('data-kld-mx-loading');
        delete root.dataset.kldMxLoading;
        var load = root.querySelector('[data-mx-loading]');
        if (load) load.remove();
        if (!built.length) {
          var empty = root.querySelector('[data-mx-empty]');
          if (empty) empty.hidden = false;
          /* nothing will ever call recalc(), so the placeholder has to go now —
             a skeleton left pulsing forever reads as "still loading" */
          var skel = root.querySelector('[data-mx-cascade-skel]');
          if (skel) skel.remove();
          return;
        }
        initKldMatrixOrder(root);
      });
      return;
    }

    root.dataset.kldMxBound = '1';

    var CATS = [];
    var src = root.querySelector('[data-kld-mx-catalog]');
    if (src) { try { CATS = JSON.parse(src.textContent) || []; } catch (e) { CATS = []; } }
    CATS = CATS.filter(function (c) { return c && c.products && c.products.length; });
    if (!CATS.length) return;

    /* `subs` is [{ n, g:[…] }] — one entry per subcategory, carrying its tipuri
       de produs (level 3 of the category menu). A hand-written „Catalog fix
       (JSON)” may still spell it as a flat array of names; normalise so the
       picker has one shape to render. Subcategories a product mentions but the
       list omits are appended, so nothing becomes unreachable. */
    CATS.forEach(function (c) {
      var seen = {};
      c.subs = (c.subs || []).map(function (s) {
        var o = (s && s.n) ? { n: s.n, g: (s.g || []).slice() } : { n: '' + s, g: [] };
        seen[o.n] = o;
        return o;
      });
      c.products.forEach(function (p) {
        if (!p.sc) return;
        var o = seen[p.sc];
        if (!o) { o = seen[p.sc] = { n: p.sc, g: [] }; c.subs.push(o); }
        if (p.gc && o.g.indexOf(p.gc) < 0) o.g.push(p.gc);
      });
    });

    /* sku → { sku, price, moq, stock, prod, col, cat, isBax }.
       A cell carries two variants — the loose unit and its bax — and both are
       indexed here, because each is its own Shopify variant with its own price,
       stock and cart line. `cell` is the loose sku, the stable id the BAX/BUC
       switch is keyed by. */
    var SKUX = {};
    CATS.forEach(function (c) {
      c.products.forEach(function (p) {
        Object.keys(p.v || {}).forEach(function (col) {
          var x = p.v[col];
          if (!x || !x[0]) return;
          SKUX[x[0]] = { sku: x[0], price: Number(x[1]) || 0, moq: 1, stock: Number(x[3]) || 0, prod: p.n, col: col, cat: c.id, cc: p.cc || '', cell: x[0], isBax: !!x[7], vid: Number(x[8]) || 0 };
          if (x[4]) {
            SKUX[x[4]] = { sku: x[4], price: Number(x[5]) || 0, moq: 1, stock: Number(x[6]) || 0, prod: p.n, col: col, cat: c.id, cc: p.cc || '', cell: x[0], isBax: true, vid: Number(x[9]) || 0 };
          }
        });
      });
    });

    /* Flat index behind the search box. Typing searches the WHOLE catalog, not
       just the open tab — a buyer looking up a code has no reason to know which
       category it lives in. Each product remembers its category so a result can
       say where it came from. */
    var ALLP = [];
    var ALLCOLS = [];
    (function () {
      var seen = {};
      CATS.forEach(function (c, ci) {
        c.products.forEach(function (p) { p._cat = c.name; p._ci = ci; ALLP.push(p); });
        c.cols.forEach(function (col) { if (!seen[col]) { seen[col] = 1; ALLCOLS.push(col); } });
      });
      var numOf = function (s) { var m = String(s).match(/^([\d,.]+)/); return m ? parseFloat(m[1].replace(',', '.')) : 1e9; };
      ALLCOLS.sort(function (a, b) {
        var ua = a.replace(/^[\d,.]+\s*/, ''), ub = b.replace(/^[\d,.]+\s*/, '');
        if (ua !== ub) return ua.localeCompare(ub, 'ro');
        return numOf(a) - numOf(b);
      });
    })();

    /* Lookup for pasted codes: 25 SKUs in this catalog contain spaces
       ("KLAV 109 1BAX"), so matching is done on a whitespace-collapsed,
       upper-cased key rather than the raw string. */
    var mxKey = function (s) { return ('' + (s == null ? '' : s)).replace(/\s+/g, ' ').trim().toUpperCase(); };
    var SKUFIND = {};
    Object.keys(SKUX).forEach(function (s) { SKUFIND[mxKey(s)] = s; });

    /* ---- cascade: same rules the Shopify Function applies ----------------
       Ported 1:1 from D:\klintensiv\klintensiv-cascade,
       extensions/cascade-discount/src/cascade.ts — segment-aware, multiplicative
       ("cascadat, nu cumulat"), thresholds compared against the NET subtotal,
       rounded ONCE at the end. Reading the same b2b.cascade_config metafield is
       what keeps this preview from disagreeing with the discount taken at
       checkout, which a hardcoded table here could not guarantee. */
    var CFG = {};
    try { CFG = JSON.parse(root.getAttribute('data-mx-cascade-config') || '{}') || {}; } catch (e) { CFG = {}; }
    var RAW_SEGMENT = root.getAttribute('data-mx-segment') || '';
    var REBATE_OK = root.getAttribute('data-mx-rebate') === '1';

    var MXSEG = kldCascadeRules(CFG, RAW_SEGMENT);
    var SEGMENT = MXSEG.segment;
    var RULES = MXSEG.rules;
    var toNet = function (v) { return kldCascadeNet(v, CFG); };
    var bestPct = function (value, rules, key) { return kldCascadeBest(value, rules, key); };
    var VOL_TIERS = RULES.volume_tiers || [];
    var RAMBURS_PP = (RULES.modifiers || {}).ramburs_pp || 0;
    var FREE_SHIP = parseFloat(root.getAttribute('data-free-ship')) || 0;
    var CREDIT_LEFT = (parseFloat(root.getAttribute('data-credit-max')) || 0) - (parseFloat(root.getAttribute('data-credit-used')) || 0);
    var cur = root.getAttribute('data-currency') || 'RON';
    var cartUrl = root.getAttribute('data-cart-url') || kldUrl('cart');
    var dynamic = root.getAttribute('data-mx-dynamic') === '1';

    var mxNf = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var ron = function (n) { return mxNf.format(Number(n) || 0); };
    var ri = function (n) { return Math.round(Number(n) || 0).toLocaleString('ro-RO'); };
    var pct = function (f) { return (f * 100).toFixed(0); };
    var esc = function (s) {
      return ('' + (s == null ? '' : s)).replace(/[&<>"]/g, function (c) {
        return c === '&' ? '&amp;' : c === '<' ? '&lt;' : c === '>' ? '&gt;' : '&quot;';
      });
    };
    var normKey = function (c) { return ('' + (c || '')).trim().toLowerCase(); };

    /* state. `qty` is ALWAYS in pieces — the BAX/BUC switch only changes the unit
       a cell is typed/stepped/displayed in, never what the quantity means. */
    var qty = {};                 /* sku → quantity, in pieces */
    var unitBy = {};              /* sku → 'bax' | 'buc' (default 'bax') */
    var catId = CATS[0].id;
    var sub2 = null;              /* active subcategory, null = toate */
    var grp3 = null;              /* active tip de produs, null = toate */
    /* cascade picker: what the flyout is PREVIEWING (hover on desktop, the pane
       you drilled into on touch) — separate from the committed selection above,
       which only changes on click. */
    var pvCat = null, pvSub = null, pickPane = 1;
    var findQ = '';
    /* Ramburs is NOT a local what-if: the discount function reads the cart
       attribute `payment_pref`, and so does the cart widget. Starting this at
       `false` while the cart said otherwise is exactly how the grid showed
       −22,5% against the cart's −20,1% — the same 3pp modifier counted on one
       side only. Initialise from the cart, and write back on toggle. */
    var ramburs = (root.getAttribute('data-mx-payment-pref') || '') === 'ramburs';
    /* normalized sku → Shopify variant id. Seeded straight from the catalog
       payload, which carries the id of every variant it emitted: that covers
       the SKU-less ones, which /products.json can never match by code. The
       products.json pass below only fills gaps (static/demo catalog). */
    var vids = {};
    Object.keys(SKUX).forEach(function (s) { if (SKUX[s].vid) vids[normKey(s)] = SKUX[s].vid; });
    var visRows = [];             /* products currently rendered, in row order */
    var openCards = {};           /* mobile: product name → card expanded */

    /* The BAX/BUC switch selects WHICH VARIANT the cell orders — a bax is its
       own SKU here, not a multiple of the loose one — so it is keyed by the
       cell (the loose sku) and defaults to BUC. Quantities are plain counts of
       whatever variant is selected; there is no unit conversion left to do. */
    var uOf = function (cell) { return unitBy[cell] === 'bax' ? 'bax' : 'buc'; };
    /* the sku a cell currently drives, given its switch */
    var skuOfCell = function (vr) {
      return (uOf(vr[0]) === 'bax' && vr[4]) ? vr[4] : vr[0];
    };
    /* "SKU · preț", or just the price when the variant has no SKU in Shopify */
    var skuPriceLabel = function (sku, price) {
      return (kldMxIsSynthSku(sku) ? '' : esc(sku) + ' · ') + ron(toNet(price));
    };
    var toUnit = function (sku, raw) { return raw || ''; };
    var boxesOf = function (sku) { var x = SKUX[sku]; return x && x.isBax ? (qty[sku] || 0) : 0; };

    /* the toolbar buttons live in the section head, outside the grid root */
    var scope = (root.closest && root.closest('.kld')) || root;
    var q1 = function (sel) { return scope.querySelector(sel); };

    var pick = root.querySelector('[data-mx-pick]');
    var pickBtn = root.querySelector('[data-mx-pick-btn]');
    var pickPop = root.querySelector('[data-mx-pick-pop]');
    var pickVal = root.querySelector('[data-mx-pick-val]');
    var pickCols = {
      1: root.querySelector('[data-mx-pick-cats]'),
      2: root.querySelector('[data-mx-pick-subs]'),
      3: root.querySelector('[data-mx-pick-grps]')
    };
    var scopeLine = root.querySelector('[data-mx-scope]');
    var L = {
      cat: root.getAttribute('data-mx-cat-label') || 'Categorie',
      sub: root.getAttribute('data-mx-sub-label') || 'Subcategorie',
      grp: root.getAttribute('data-mx-grp-label') || 'Tip de produs',
      all: root.getAttribute('data-mx-all-label') || 'Toate'
    };
    var thead = root.querySelector('[data-mx-thead]');
    var tbody = root.querySelector('[data-mx-tbody]');
    var findIn = root.querySelector('[data-mx-find]');
    var errBox = root.querySelector('[data-mx-errors]');
    var casWrap = root.querySelector('[data-mx-cascade]');
    var nudgeWrap = root.querySelector('[data-mx-nudge]');
    var cardsWrap = root.querySelector('[data-mx-cards]');
    var gridCard = root.querySelector('.kld-mx__gridcard');
    var noRes = root.querySelector('[data-mx-noresults]');
    var sheet = root.querySelector('[data-mx-sheet]');
    var addBtns = root.querySelectorAll('[data-mx-addall]');
    var addBtn = addBtns[0];
    var saveBtn = root.querySelector('[data-mx-save]');
    var setAddDisabled = function (off) {
      Array.prototype.forEach.call(addBtns, function (b) { b.disabled = off; });
    };
    var curCat = function () { return CATS.filter(function (c) { return c.id === catId; })[0] || CATS[0]; };
    var setT = function (sel, txt) { var e = root.querySelector(sel); if (e) e.textContent = txt; };

    /* how many cells of a product list currently carry a quantity */
    var filledIn = function (products) {
      return products.reduce(function (a, p) {
        return a + Object.keys(p.v || {}).filter(function (k) { return qty[p.v[k][0]] > 0; }).length;
      }, 0);
    };

    /* ---- cascade picker (categorie › subcategorie › tip de produs) --------
       The prototype's navigation, ported: one control carrying the whole path,
       opening a three-column flyout. Columns 2 and 3 are rendered from
       pvCat/pvSub, which hover moves on desktop and a tap moves on touch — the
       committed selection (catId/sub2/grp3) only changes on click. */
    var catById = function (id) { return CATS.filter(function (c) { return c.id === id; })[0] || null; };
    var subByName = function (C, n) { return C ? (C.subs || []).filter(function (s) { return s.n === n; })[0] || null : null; };
    var prodsInSub = function (C, n) { return C.products.filter(function (p) { return p.sc === n; }); };
    var prodsInGrp = function (C, n, g) { return C.products.filter(function (p) { return p.sc === n && p.gc === g; }); };
    /* a subcategory only earns a third column when it really has tipuri that
       carry products — otherwise selecting it goes straight to the grid */
    var grpsOf = function (C, s) {
      return s ? (s.g || []).filter(function (g) { return prodsInGrp(C, s.n, g).length; }) : [];
    };
    var pickIsOpen = function () { return pickPop && !pickPop.hidden; };
    /* One flyout, two behaviours: hover-preview above 780px, pane-by-pane
       drill-down below it, where there is no hover to preview with. */
    var pickIsSheet = function () {
      return window.matchMedia && window.matchMedia('(max-width: 780px)').matches;
    };

    var pickRow = function (attrs, label, meta, opts) {
      return '<button type="button" class="kld-mx__pick-it' +
          (opts.on ? ' is-on' : '') + (opts.sel ? ' is-sel' : '') + (opts.all ? ' kld-mx__pick-it--all' : '') + '" ' + attrs + '>' +
        '<span class="kld-mx__pick-it-t"><b>' + esc(label) + '</b>' +
          (meta ? '<span>' + esc(meta) + '</span>' : '') + '</span>' +
        (opts.dot ? '<span class="kld-mx__pick-dot"></span>' : '') +
        (opts.sel ? '<span class="kld-mx__pick-ck">' + KLD_CHECK + '</span>'
                  : (opts.more ? '<span class="kld-mx__pick-ch">' + KLD_MX_CHEV_R + '</span>' : '')) +
      '</button>';
    };

    function renderPicker() {
      var C = curCat();
      if (pickVal) {
        /* The path is split into ancestors + leaf so the ellipsis eats the
           ancestors first: on a phone the whole thing never fits, and the level
           the buyer just chose is the one worth keeping legible. */
        var trail = [C ? C.name : ''];
        if (sub2) trail.push(sub2);
        if (grp3) trail.push(grp3);
        var leaf = trail.pop();
        pickVal.innerHTML =
          (trail.length ? '<span class="kld-mx__pick-path">' + esc(trail.join(' › ')) + ' › </span>' : '') +
          '<span class="kld-mx__pick-leaf">' + esc(leaf) + '</span>';
        pickVal.setAttribute('title', trail.concat([leaf]).join(' › '));
      }
      if (!pickPop || pickPop.hidden) return;

      /* what the flyout is showing, which is not necessarily what is selected */
      var PC = catById(pvCat) || C;
      var PS = subByName(PC, pvSub);
      /* the „Toate …” rows are a sheet-only affordance — see the columns below */
      var sheet = pickIsSheet();

      if (pickCols[1]) {
        pickCols[1].innerHTML = CATS.map(function (c) {
          var n = c.products.length;
          return pickRow('data-mx-pick-cat="' + esc(c.id) + '"', c.name,
            n + (n === 1 ? ' produs' : ' produse'),
            { on: PC && c.id === PC.id, sel: c.id === catId && !sub2, dot: !!filledIn(c.products),
              more: (c.subs || []).length > 0 });
        }).join('');
      }

      if (pickCols[2]) {
        if (!PC || !(PC.subs || []).length) {
          pickCols[2].innerHTML = '<div class="kld-mx__pick-none">' + esc('Fără ' + L.sub.toLowerCase()) + '</div>';
        } else {
          /* „Toate · <categorie>" on the SHEET only. On desktop the columns are
             side by side, so selecting the whole category is simply the click on
             the category itself in the column to the left — the row would be a
             duplicate. In the sheet that column is a pane you have already left
             behind, so the row is the only way back to "all of it". */
          var html2 = !sheet ? '' : pickRow('data-mx-pick-sub=""', L.all + ' · ' + PC.name,
            PC.products.length + (PC.products.length === 1 ? ' produs' : ' produse'),
            { sel: PC.id === catId && !sub2, all: true });
          (PC.subs || []).forEach(function (s) {
            var ps = prodsInSub(PC, s.n);
            if (!ps.length) return;
            html2 += pickRow('data-mx-pick-sub="' + esc(s.n) + '"', s.n,
              ps.length + (ps.length === 1 ? ' produs' : ' produse'),
              { on: PS && PS.n === s.n, sel: PC.id === catId && sub2 === s.n && !grp3,
                dot: !!filledIn(ps), more: grpsOf(PC, s).length > 0 });
          });
          pickCols[2].innerHTML = html2;
        }
      }

      if (pickCols[3]) {
        var gs = grpsOf(PC, PS);
        if (!PS || !gs.length) {
          pickCols[3].innerHTML = '<div class="kld-mx__pick-none">' +
            esc(PS ? 'Fără ' + L.grp.toLowerCase() : 'Alege o ' + L.sub.toLowerCase()) + '</div>';
        } else {
          /* likewise, sheet only: on desktop the whole subcategory is the row in
             the middle column, one click away */
          var ps2 = prodsInSub(PC, PS.n);
          var html3 = !sheet ? '' : pickRow('data-mx-pick-grp=""', L.all + ' · ' + PS.n,
            ps2.length + (ps2.length === 1 ? ' produs' : ' produse'),
            { sel: PC.id === catId && sub2 === PS.n && !grp3, all: true });
          gs.forEach(function (g) {
            var pg = prodsInGrp(PC, PS.n, g);
            html3 += pickRow('data-mx-pick-grp="' + esc(g) + '"', g,
              pg.length + (pg.length === 1 ? ' produs' : ' produse'),
              { sel: PC.id === catId && sub2 === PS.n && grp3 === g, dot: !!filledIn(pg) });
          });
          pickCols[3].innerHTML = html3;
        }
      }

      /* the sheet shows one pane at a time and titles it */
      pickPop.setAttribute('data-pane', pickPane);
      var bt = root.querySelector('[data-mx-pick-bar-title]');
      if (bt) bt.textContent = pickPane === 3 ? L.grp : pickPane === 2 ? L.sub : L.cat;
      var back = root.querySelector('[data-mx-pick-back]');
      if (back) {
        back.hidden = pickPane === 1;
        var bl = back.querySelector('[data-mx-pick-back-label]');
        if (bl) bl.textContent = pickPane === 3 ? (PC ? PC.name : L.cat) : L.cat;
      }
    }

    /* The line under the picker: what the current selection puts on screen, or
       — while searching — where the results came from, since the picker no
       longer describes them. */
    function renderScope() {
      if (!scopeLine) return;
      if (searching()) {
        var cats = {};
        visRows.forEach(function (p) { cats[p._cat] = 1; });
        var nCat = Object.keys(cats).length;
        scopeLine.innerHTML = '<span class="kld-mx__searchnote">' +
          esc(visRows.length
            ? visRows.length + (visRows.length === 1 ? ' rezultat' : ' rezultate') +
              ' din ' + nCat + (nCat === 1 ? ' categorie' : ' categorii') + ' — caut în tot catalogul'
            : 'Niciun rezultat în tot catalogul') +
          '</span>';
        return;
      }
      var nP = visRows.length, nC = visCols.length;
      scopeLine.innerHTML = '<span class="kld-mx__scope-t">' +
        esc(nP + (nP === 1 ? ' produs' : ' produse') + ' · ' +
            nC + (nC === 1 ? ' ambalaj' : ' ambalaje') + ' pe orizontală') + '</span>';
    }

    function openPick(open) {
      if (!pickPop || !pickBtn) return;
      if (open) {
        pvCat = catId; pvSub = sub2;
        pickPane = 1;
        pickPop.hidden = false;
        pickBtn.setAttribute('aria-expanded', 'true');
        renderPicker();
      } else {
        pickPop.hidden = true;
        pickBtn.setAttribute('aria-expanded', 'false');
      }
      if (pick) pick.classList.toggle('is-open', !!open);
      document.body.classList.toggle('kld-mx-picking', !!open && pickIsSheet());
    }

    /* Select a level WITHOUT dismissing. On the sheet this fires on the way down
       as well: every tap commits the branch it touched and then drills, so
       closing at any depth leaves that level selected. That is what replaced the
       „Toate …” rows — stopping at a category or a subcategory needs no row of
       its own, it is just the tap you already made. */
    function applyPick(cid, s, g) {
      catId = cid; sub2 = s || null; grp3 = g || null;
      findQ = '';
      if (findIn) findIn.value = '';
      renderAll();
    }
    function commitPick(cid, s, g) { openPick(false); applyPick(cid, s, g); }

    /* Columns actually used by the rows on screen. The full catalog has far more
       packagings than any one view needs — Dezinfectanți alone spans 39 once bax
       twins are counted — and a column no visible row fills is a screenful of
       "—". Narrowing per view keeps the grid readable as the buyer filters. */
    var colsFor = function (cols, rows) {
      var used = {};
      rows.forEach(function (p) { Object.keys(p.v || {}).forEach(function (k) { used[k] = 1; }); });
      var out = cols.filter(function (c) { return used[c]; });
      return out.length ? out : cols;
    };
    var visCols = [];
    /* true while the search box has text: category and subcategory stop
       restricting, so a code is found wherever it lives */
    var searching = function () { return findQ.trim().length > 0; };
    /* every cell's sku plus the product name and its category, so a search hits
       both "Alchosept" and "ALC-1L" */
    var hayOf = function (p) {
      var skus = [];
      Object.keys(p.v || {}).forEach(function (k) {
        var c = p.v[k];
        if (c[0] && !kldMxIsSynthSku(c[0])) skus.push(c[0]);
        if (c[4] && !kldMxIsSynthSku(c[4])) skus.push(c[4]);
      });
      return (p.n + ' ' + (p.sub || '') + ' ' + (p.sc || '') + ' ' + (p.gc || '') + ' ' + (p._cat || '') + ' ' + skus.join(' ')).toLowerCase();
    };
    /* The branch badge on a row names only what the current selection does NOT
       already say: the full path while searching, the subcategory when the
       picker stopped at the category, the tip de produs when it stopped at the
       subcategory, and nothing once the tip itself is selected. */
    var tagOf = function (p) {
      if (searching()) return p._cat + (p.sc ? ' · ' + p.sc : '') + (p.gc ? ' · ' + p.gc : '');
      if (!sub2) return p.sc || '';
      if (!grp3) return p.gc || '';
      return '';
    };

    function renderGrid() {
      var C = curCat();
      if (!tbody) return;
      var needle = findQ.trim().toLowerCase();
      var all = !!needle;
      visRows = (all ? ALLP : C.products).filter(function (p) {
        if (!all) return (!sub2 || p.sc === sub2) && (!grp3 || p.gc === grp3);
        return hayOf(p).indexOf(needle) >= 0;
      });
      if (all) visRows.sort(function (a, b) { return (a._ci - b._ci) || a.n.localeCompare(b.n, 'ro'); });
      visCols = colsFor(all ? ALLCOLS : C.cols, visRows);

      /* Nothing matched → swap the whole grid for the placeholder card. Leaving
         the table up would show a header row of packagings under a "no results"
         line, which reads like a partial answer rather than none. */
      var none = !visRows.length;
      if (gridCard) gridCard.hidden = none;
      if (noRes) {
        noRes.hidden = !none;
        if (none) {
          var msg = findQ.trim()
            ? 'Niciun produs nu conține „' + findQ.trim() + '” în tot catalogul.'
            : 'Nu există produse în această selecție.';
          var t = noRes.querySelector('[data-mx-noresults-text]');
          if (t) t.textContent = msg;
          var btn = noRes.querySelector('[data-mx-clear-search]');
          if (btn) btn.hidden = !findQ.trim();
        }
      }
      if (none) { tbody.innerHTML = ''; if (thead) thead.innerHTML = ''; return; }

      if (thead) {
        thead.innerHTML = '<tr><th class="kld-mx__th-prod">Produs</th>' +
          visCols.map(function (col) { return '<th>' + esc(col) + '</th>'; }).join('') +
          '<th class="kld-mx__th-sum">Subtotal linie</th></tr>';
      }
      tbody.innerHTML = visRows.map(function (p, r) {
        var cells = visCols.map(function (col, c) {
          var vr = (p.v || {})[col];
          if (!vr) return '<td class="kld-mx__td kld-mx__td--empty">—</td>';
          var cell = vr[0], u = uOf(cell), hasBax = !!vr[4];
          var sku = skuOfCell(vr);
          var price = (u === 'bax' && hasBax) ? vr[5] : vr[1];
          /* No bax for this packaging → the BAX side reads "—" and is inert,
             rather than silently ordering the loose unit instead. */
          var unitBtn = function (k, label) {
            var off = k === 'bax' && !hasBax;
            return '<button type="button" class="kld-mx__unit-b' + (u === k ? ' is-on' : '') + (off ? ' is-off' : '') + '"' +
              ' data-mx-unit="' + k + '" data-cell="' + esc(cell) + '"' + (off ? ' disabled title="Fără bax"' : '') +
              ' aria-pressed="' + (u === k) + '">' + (off ? '—' : label) + '</button>';
          };
          return '<td class="kld-mx__td"><div class="kld-mx__cell">' +
            '<div class="kld-mx__unit" role="group" aria-label="Unitate de comandă">' + unitBtn('bax', 'BAX') + unitBtn('buc', 'BUC') + '</div>' +
            '<div class="kld-mx__stepper">' +
              '<button type="button" class="kld-mx__step" data-mx-bump="-1" data-sku="' + esc(sku) + '" aria-label="Scade cu 1 ' + u + '">−</button>' +
              '<input type="text" class="kld-mx__qty" inputmode="numeric" autocomplete="off" placeholder="0"' +
                ' value="' + toUnit(sku, qty[sku]) + '" data-sku="' + esc(sku) + '" data-r="' + r + '" data-c="' + c + '"' +
                ' aria-label="' + esc(p.n + ' ' + col) + ' (' + u + ')">' +
              '<button type="button" class="kld-mx__step" data-mx-bump="1" data-sku="' + esc(sku) + '" aria-label="Crește cu 1 ' + u + '">+</button>' +
            '</div>' +
            '<span class="kld-mx__sku">' + skuPriceLabel(sku, price) + '</span>' +
            '<span class="kld-mx__stock" data-mx-meta data-sku="' + esc(sku) + '"></span>' +
          '</div></td>';
        }).join('');
        return '<tr class="kld-mx__row" data-row="' + r + '">' +
          '<td class="kld-mx__prod">' +
            '<b class="kld-mx__prod-n">' + esc(p.n) + '</b>' +
            '<span class="kld-mx__prod-s">' + esc(p.sub || '') + '</span>' +
            (tagOf(p) ? '<span class="kld-mx__prod-tag">' + esc(tagOf(p)) + '</span>' : '') +
          '</td>' + cells +
          '<td class="kld-mx__linesum" data-mx-linesum>—</td></tr>';
      }).join('');
    }

    /* Mobile layout (≤780px): the same rows as stacked product cards, each one
       expanding into its packagings. Rendered alongside the grid — CSS shows
       exactly one — so both share `qty`, the handlers and recalc. */
    function renderCards() {
      if (!cardsWrap) return;
      if (!visRows.length) { cardsWrap.innerHTML = ''; return; }
      var C = curCat();
      cardsWrap.innerHTML = visRows.map(function (p, r) {
        var cols = visCols.filter(function (col) { return (p.v || {})[col]; });
        var packs = cols.map(function (col, c) {
          var vr = p.v[col], cell = vr[0], u = uOf(cell), hasBax = !!vr[4];
          var sku = skuOfCell(vr);
          var price = (u === 'bax' && hasBax) ? vr[5] : vr[1];
          var stock = (u === 'bax' && hasBax) ? Number(vr[6]) || 0 : Number(vr[3]) || 0;
          var unitBtn = function (k, label) {
            var off = k === 'bax' && !hasBax;
            return '<button type="button" class="kld-mx__unit-b' + (u === k ? ' is-on' : '') + (off ? ' is-off' : '') + '"' +
              ' data-mx-unit="' + k + '" data-cell="' + esc(cell) + '"' + (off ? ' disabled title="Fără bax"' : '') +
              ' aria-pressed="' + (u === k) + '">' + (off ? '—' : label) + '</button>';
          };
          return '<div class="kld-mxm__pack">' +
            '<div class="kld-mxm__pack-l">' +
              '<div class="kld-mx__unit" role="group" aria-label="Unitate de comandă">' + unitBtn('bax', 'BAX') + unitBtn('buc', 'BUC') + '</div>' +
              '<b>' + esc(col) + '</b>' +
              '<span>' + skuPriceLabel(sku, price) + '</span>' +
              '<span class="kld-mxm__st' + (stock < 30 ? ' is-low' : '') + '">stoc ' + ri(stock) + '</span>' +
            '</div>' +
            '<div class="kld-mxm__step">' +
              '<button type="button" data-mx-bump="-1" data-sku="' + esc(sku) + '" aria-label="Scade cu 1 ' + u + '">−</button>' +
              '<input type="text" class="kld-mx__qty" inputmode="numeric" autocomplete="off" placeholder="0"' +
                ' value="' + toUnit(sku, qty[sku]) + '" data-sku="' + esc(sku) + '"' +
                ' aria-label="' + esc(p.n + ' ' + col) + ' (' + u + ')">' +
              '<button type="button" data-mx-bump="1" data-sku="' + esc(sku) + '" aria-label="Crește cu 1 ' + u + '">+</button>' +
            '</div>' +
            '<span class="kld-mxm__conv" data-mx-conv data-sku="' + esc(sku) + '"></span>' +
          '</div>';
        }).join('');
        var key = esc(p.n);
        return '<div class="kld-mxm__card' + (openCards[p.n] ? ' is-open' : '') + '" data-row="' + r + '">' +
          '<button type="button" class="kld-mxm__card-h" data-mx-card-toggle="' + key + '" aria-expanded="' + !!openCards[p.n] + '">' +
            '<span class="kld-mxm__card-t">' +
              '<b>' + esc(p.n) + '</b>' +
              '<span class="s">' + esc(p.sub || '') + '</span>' +
              (tagOf(p) ? '<span class="kld-mxm__tag">' + esc(tagOf(p)) + '</span>' : '') +
            '</span>' +
            '<span class="kld-mxm__card-sum"><b data-mx-cardsum data-row="' + r + '">—</b>' +
              '<span>' + cols.length + (cols.length === 1 ? ' ambalaj' : ' ambalaje') + '</span></span>' +
            '<span class="kld-mxm__chev">' + KLD_MX_CHEV + '</span>' +
          '</button>' +
          '<div class="kld-mxm__packs">' + packs + '</div>' +
        '</div>';
      }).join('');
    }

    /* Recomputes everything derived from `qty` WITHOUT rebuilding the grid, so a
       cell keeps focus/caret while the buyer types. */
    function recalc() {
      var lines = Object.keys(qty).filter(function (s) { return qty[s] > 0 && SKUX[s]; });
      var sub = 0, units = 0, used = {};
      lines.forEach(function (s) {
        sub += qty[s] * SKUX[s].price; units += qty[s];
        /* distinct CASCADE categories, exactly as the function counts them:
           custom.cascade_discount_category, and products without one don't count */
        if (SKUX[s].cc) used[SKUX[s].cc] = 1;
      });
      var nCats = Object.keys(used).length;

      /* `sub` is VAT-inclusive RON; the tiers are NET bani */
      var netSub = toNet(sub);
      var p1 = bestPct(netSub * 100, VOL_TIERS, 'min_net');
      var p2 = bestPct(nCats, RULES.assortment, 'min_categories');
      var p3 = ramburs ? RAMBURS_PP : 0;
      var pReb = REBATE_OK ? ((CFG.rebate && CFG.rebate.pct) || 0) : 0;
      var mul = function (x) { return 1 - x / 100; };
      var product = mul(p1) * mul(p2) * mul(p3) * mul(pReb);
      var equiv = Math.round(((1 - product) * 100 + Number.EPSILON) * 100) / 100 / 100;
      var dVol = p1 / 100, dSort = p2 / 100, dFin = p3 / 100;
      var final = sub * product;
      /* next volume threshold, in NET bani */
      var nextVol = null, bestNext = Infinity;
      VOL_TIERS.forEach(function (t) {
        if (netSub * 100 < t.min_net && t.min_net < bestNext) { bestNext = t.min_net; nextVol = t; }
      });
      var minOrderNet = RULES.min_order_net || 0;
      var belowMin = minOrderNet > 0 && netSub * 100 < minOrderNet;

      /* per-row totals + active state, in BOTH layouts */
      visRows.forEach(function (p, r) {
        var rowSum = Object.keys(p.v || {}).reduce(function (a, col) {
          var c = p.v[col];
          return a + (qty[c[0]] || 0) * c[1] + (c[4] ? (qty[c[4]] || 0) * c[5] : 0);
        }, 0);
        var rowEl = tbody && tbody.querySelector('tr[data-row="' + r + '"]');
        if (rowEl) {
          rowEl.classList.toggle('is-active', rowSum > 0);
          var ls = rowEl.querySelector('[data-mx-linesum]');
          if (ls) { ls.textContent = rowSum ? ron(toNet(rowSum)) + ' ' + cur : '—'; ls.classList.toggle('is-set', rowSum > 0); }
        }
        var card = cardsWrap && cardsWrap.querySelector('.kld-mxm__card[data-row="' + r + '"]');
        if (card) {
          card.classList.toggle('is-active', rowSum > 0);
          /* no currency suffix here — the card header is narrow and the bar /
             sheet already carry the unit */
          var cs = card.querySelector('[data-mx-cardsum]');
          if (cs) { cs.textContent = rowSum ? ron(toNet(rowSum)) : '—'; cs.classList.toggle('is-set', rowSum > 0); }
        }
      });
      /* per-cell validity + value sync. Every layout renders the same hooks, so
         one pass covers grid and cards; the focused input is left alone so the
         caret survives typing, its twin in the other layout is rewritten. */
      root.querySelectorAll('.kld-mx__qty').forEach(function (inp) {
        var x = SKUX[inp.getAttribute('data-sku')];
        if (!x) return;
        var v = qty[x.sku] || 0;
        /* In BAX mode a quantity is a whole number of boxes by construction, so
           only BUC entry can land off-multiple. Over-stock is bad either way. */
        var bad = v > 0 && v > x.stock;
        inp.classList.toggle('is-set', v > 0);
        inp.classList.toggle('is-bad', bad);
        if (inp !== document.activeElement) inp.value = toUnit(x.sku, v);
      });
      /* grid: the line under each cell is the conversion once filled, else bax/stock */
      root.querySelectorAll('[data-mx-meta]').forEach(function (el) {
        var x = SKUX[el.getAttribute('data-sku')];
        if (!x) return;
        var v = qty[x.sku] || 0;
        el.className = 'kld-mx__stock' + (v ? ' is-conv' : (x.stock < 30 ? ' is-low' : ''));
        el.textContent = v
          ? (x.isBax ? ri(v) + (v === 1 ? ' bax' : ' baxuri') : ri(v) + ' buc')
          : ('stoc ' + ri(x.stock));
      });
      /* cards: the conversion sits beside the stepper, blank until filled */
      root.querySelectorAll('[data-mx-conv]').forEach(function (el) {
        var x = SKUX[el.getAttribute('data-sku')];
        if (!x) return;
        var v = qty[x.sku] || 0;
        el.textContent = v ? (x.isBax ? ri(v) + ' bax' : ri(v) + ' buc') : '';
      });

      /* MOQ multiples + stock */
      var errs = [];
      lines.forEach(function (s) {
        var x = SKUX[s];
        if (qty[s] > x.stock) errs.push(x.prod + ' ' + x.col + ': doar ' + ri(x.stock) + ' buc în stoc');
      });
      if (errBox) {
        errBox.hidden = !errs.length;
        if (errs.length) {
          setT('[data-mx-errors-title]', errs.length + (errs.length === 1 ? ' linie necesită corecție' : ' linii necesită corecție'));
          var list = root.querySelector('[data-mx-errors-list]');
          if (list) list.innerHTML = errs.slice(0, 4).map(function (t) { return '<div class="kld-mx__errors-line">' + esc(t) + '</div>'; }).join('');
        }
      }

      /* discount cascade */
      if (casWrap) {
        var rows = [
          ['Subtotal (fără TVA)', ron(netSub) + ' ' + cur, ''],
          ['PAS 1 · Volum' + (p1 ? '' : ' (fără prag atins)'), p1 ? '−' + p1 + '%' : '—', p1 ? 'is-on' : 'is-off'],
          ['PAS 2 · Sortimentație (' + nCats + (nCats === 1 ? ' categorie)' : ' categorii)'), p2 ? '−' + p2 + '%' : '—', p2 ? 'is-on' : 'is-off']
        ];
        if (RAMBURS_PP > 0) rows.push(['PAS 3 · Financiar / Logistic', p3 ? '−' + p3 + '%' : '—', p3 ? 'is-on' : 'is-off']);
        if (pReb > 0) rows.push(['Rebate trimestrial', '−' + pReb + '%', 'is-on']);
        casWrap.innerHTML = rows.map(function (r) {
          return '<div class="kld-mx__crow"><span>' + esc(r[0]) + '</span><b class="' + r[2] + '">' + esc(r[1]) + '</b></div>';
        }).join('');
      }
      if (nudgeWrap) {
        var html = '';
        var maxVolPct = VOL_TIERS.reduce(function (a, t) { return Math.max(a, t.pct || 0); }, 0);
        if (sub > 0 && nextVol) {
          html = '<div class="kld-mx__nudge kld-mx__nudge--info">' + KLD_MX_UP +
            '<span>Mai adaugi <b>' + ron(nextVol.min_net / 100 - netSub) + ' ' + cur + '</b> fără TVA → pragul <b>−' + nextVol.pct + '%</b></span></div>';
        } else if (sub > 0 && VOL_TIERS.length) {
          html = '<div class="kld-mx__nudge kld-mx__nudge--done">' + KLD_CHECK +
            '<span>Prag maxim de volum atins (−' + maxVolPct + '%)</span></div>';
        }
        if (belowMin) {
          html += '<div class="kld-mx__nudge kld-mx__nudge--warn">' + KLD_MX_ALERT +
            '<span>Sub pragul minim de comandă (' + ron(minOrderNet / 100) + ' ' + cur + ' fără TVA)</span></div>';
        }
        var nextAssort = null;
        (RULES.assortment || []).forEach(function (r) {
          if (nCats < r.min_categories && (!nextAssort || r.min_categories < nextAssort.min_categories)) nextAssort = r;
        });
        if (sub > 0 && nextAssort) html += '<div class="kld-mx__hint">Încă ' + (nextAssort.min_categories - nCats) +
          ' categorie/categorii distincte → sortimentație −' + nextAssort.pct + '%.</div>';
        nudgeWrap.innerHTML = html;
      }

      /* summary */
      setT('[data-mx-lines]', lines.length);
      setT('[data-mx-baxes]', ri(lines.reduce(function (a, s) { return a + boxesOf(s); }, 0)));
      setT('[data-mx-units]', ri(units));
      setT('[data-mx-equiv]', '−' + (equiv * 100).toFixed(2).replace('.', ',') + '%');
      setT('[data-mx-total]', ron(toNet(final)));
      var ship = root.querySelector('[data-mx-ship]');
      if (ship) {
        var freeOk = FREE_SHIP > 0 && netSub >= FREE_SHIP;
        ship.className = 'kld-mx__sum-note' + (freeOk ? ' is-ok' : '');
        ship.hidden = FREE_SHIP <= 0;
        ship.innerHTML = FREE_SHIP > 0
          ? (freeOk ? KLD_CHECK + '<span>Transport gratuit inclus</span>' : '<span>Transport gratuit peste ' + ri(FREE_SHIP) + ' ' + cur + ' fără TVA</span>')
          : '';
      }
      var credit = root.querySelector('[data-mx-credit]');
      if (credit) {
        var over = CREDIT_LEFT > 0 && final > CREDIT_LEFT;
        credit.className = 'kld-mx__sum-note' + (over ? ' is-bad' : '');
        /* No credit plafond configured → hide the row outright. Left in the DOM
           empty it still carries the note's margin and opens a gap in the card. */
        credit.hidden = CREDIT_LEFT <= 0;
        credit.innerHTML = CREDIT_LEFT > 0
          ? (over
              ? KLD_MX_ALERT + '<span>Depășește creditul disponibil (' + ri(CREDIT_LEFT) + ' ' + cur + ')</span>'
              : '<span>Credit Net 30 disponibil: ' + ri(CREDIT_LEFT) + ' ' + cur + '</span>')
          : '';
      }
      var rbWrap = root.querySelector('[data-mx-ramburs-wrap]');
      if (rbWrap) {
        rbWrap.hidden = RAMBURS_PP <= 0;
        var rbl = rbWrap.querySelector('[data-mx-ramburs-label]');
        if (rbl) rbl.textContent = 'Plată ramburs (+' + RAMBURS_PP + '% discount)';
      }
      setAddDisabled(!lines.length);
      if (saveBtn) saveBtn.disabled = !lines.length;
      root.querySelectorAll('[data-mx-ramburs]').forEach(function (b) { b.checked = ramburs; });

      /* ---- mobile: sticky bottom bar + summary sheet ---- */
      var nBax = lines.reduce(function (a, s) { return a + boxesOf(s); }, 0);
      var prog = root.querySelector('[data-mx-prog]');
      if (prog) {
        if (!VOL_TIERS.length || !sub) prog.innerHTML = '';
        else if (nextVol) {
          prog.innerHTML = '<div class="t"><span>Următorul prag <b>−' + nextVol.pct + '%</b></span>' +
            '<span>încă <b>' + ron(nextVol.min_net / 100 - netSub) + ' ' + cur + '</b></span></div>' +
            '<div class="track"><div class="fill" style="width:' + Math.min(100, netSub * 100 / nextVol.min_net * 100).toFixed(1) + '%"></div></div>';
        } else {
          prog.innerHTML = '<div class="t"><span>Prag maxim de volum atins <b>−' +
            VOL_TIERS.reduce(function (a, t) { return Math.max(a, t.pct || 0); }, 0) + '%</b></span></div>' +
            '<div class="track"><div class="fill" style="width:100%"></div></div>';
        }
      }
      setT('[data-mx-mtotal]', ron(toNet(final)) + ' ' + cur);
      var mdisc = root.querySelector('[data-mx-mdisc]');
      if (mdisc) mdisc.textContent = sub ? '−' + (equiv * 100).toFixed(2).replace('.', ',') + '%' : '';
      setT('[data-mx-mmeta]', lines.length + (lines.length === 1 ? ' linie · ' : ' linii · ') +
        ri(nBax) + (nBax === 1 ? ' bax · ' : ' baxuri · ') + ri(units) + ' buc' +
        (errs.length ? ' · ' + errs.length + ' de corectat' : ''));
      var sheetBody = root.querySelector('[data-mx-sheet-body]');
      if (sheetBody && sheet && !sheet.hidden) {
        sheetBody.innerHTML =
          (casWrap ? casWrap.innerHTML : '') +
          (RAMBURS_PP > 0 ? '<label class="kld-mx__check"><input type="checkbox" data-mx-ramburs' + (ramburs ? ' checked' : '') + '>Plată ramburs (+' + RAMBURS_PP + '% discount)</label>' : '') +
          '<div class="kld-mxm__srow"><span>Linii</span><b>' + lines.length + '</b></div>' +
          '<div class="kld-mxm__srow"><span>Baxuri</span><b>' + ri(nBax) + '</b></div>' +
          '<div class="kld-mxm__srow"><span>Bucata (total)</span><b>' + ri(units) + '</b></div>' +
          '<div class="kld-mxm__srow"><span>Discount echivalent</span><b>−' + (equiv * 100).toFixed(2).replace('.', ',') + '%</b></div>' +
          '<div class="kld-mxm__srow kld-mxm__srow--tot"><span>Total (fără TVA)</span><b>' + ron(toNet(final)) + ' ' + cur + '</b></div>' +
          (nudgeWrap ? nudgeWrap.innerHTML : '');
      }

      /* the picker carries a "has quantities" dot per branch, so it is repainted
         on every recalc — but only while it is open, since the button label
         itself depends on the selection, not on the quantities */
      renderPicker();
      renderScope();
    }

    function renderAll() { renderGrid(); renderCards(); recalc(); }

    var setCell = function (sku, val) {
      var v = parseInt(val, 10);
      if (isNaN(v) || v < 0) v = 0;
      if (v === 0) delete qty[sku]; else qty[sku] = v;
    };
    /* what the buyer typed is in the cell's unit — store it as pieces */
    var setCellUnit = function (sku, val) {
      var v = parseInt(val, 10);
      if (isNaN(v) || v < 0) v = 0;
      setCell(sku, uOf(sku) === 'bax' ? v * (SKUX[sku].moq || 1) : v);
    };

    /* ---- events ---- */

    /* ---- cascade picker ----
       Desktop: hovering a row previews the next column, clicking commits and
       closes. Touch (≤780px): the flyout is a bottom sheet, so a row with
       children drills into the next pane instead — the „Toate …” row at the top
       of each pane is what commits at that level. */

    /* Where the press started, so a DRAG is never taken for a tap. Scrolling the
       sheet's list is a slow press-move-release over a row, and the browser
       still delivers a `click` on that row: without this, swiping the list
       picked whatever branch the finger started on and dismissed the sheet.
       Shared by the picker's own handler and the click-away one below. */
    var pressAt = null;
    document.addEventListener('pointerdown', function (e) { pressAt = [e.clientX, e.clientY]; }, true);
    var wasDrag = function (e) {
      /* `detail` is 0 on a click the keyboard synthesised (Enter/Space on the
         focused row), which also reports clientX/clientY 0 — measuring that
         against the last press would read as a huge drag and swallow every
         keyboard activation. Only a real pointer click can be a drag. */
      if (!e.detail) return false;
      return !!pressAt && Math.abs(e.clientX - pressAt[0]) + Math.abs(e.clientY - pressAt[1]) > 10;
    };

    if (pickBtn) pickBtn.addEventListener('click', function () { openPick(!pickIsOpen()); });
    if (pickPop) {
      pickPop.addEventListener('mouseover', function (e) {
        if (pickIsSheet()) return;
        var c = e.target.closest('[data-mx-pick-cat]');
        if (c) {
          var id = c.getAttribute('data-mx-pick-cat');
          if (id === pvCat) return;
          pvCat = id;
          /* preview the sub the buyer already picked, if it lives here */
          pvSub = (id === catId) ? sub2 : null;
          renderPicker();
          return;
        }
        var s = e.target.closest('[data-mx-pick-sub]');
        if (s) {
          var n = s.getAttribute('data-mx-pick-sub') || null;
          if (n === pvSub) return;
          pvSub = n;
          renderPicker();
        }
      });
      pickPop.addEventListener('click', function (e) {
        if (wasDrag(e)) return;                    /* a swipe of the list, not a pick */
        if (e.target.closest('[data-mx-pick-close]')) { openPick(false); return; }
        if (e.target.closest('[data-mx-pick-back]')) {
          pickPane = Math.max(1, pickPane - 1);
          renderPicker();
          return;
        }
        var sheet2 = pickIsSheet();
        var c = e.target.closest('[data-mx-pick-cat]');
        if (c) {
          var id = c.getAttribute('data-mx-pick-cat');
          var C2 = catById(id);
          if (sheet2 && C2 && (C2.subs || []).length) {
            /* state first — applyPick repaints the sheet from it */
            pvCat = id; pvSub = null; pickPane = 2;
            applyPick(id, null, null);
          } else {
            commitPick(id, null, null);
          }
          return;
        }
        var s = e.target.closest('[data-mx-pick-sub]');
        if (s) {
          var n = s.getAttribute('data-mx-pick-sub');
          var PC = catById(pvCat) || curCat();
          if (sheet2 && grpsOf(PC, subByName(PC, n)).length) {
            pvSub = n; pickPane = 3;
            applyPick(PC.id, n, null);
          } else {
            commitPick(PC.id, n, null);
          }
          return;
        }
        var g = e.target.closest('[data-mx-pick-grp]');
        if (g) {
          var PC2 = catById(pvCat) || curCat();
          commitPick(PC2.id, pvSub, g.getAttribute('data-mx-pick-grp') || null);
        }
      });
    }
    /* Leaving the control closes it, as in the prototype — safe now only because
       the panel sits FLUSH under the button (top: 100%): the 6px gap it used to
       have belonged to neither element, so a slow move down fired mouseleave and
       the panel vanished under a pointer that was on its way into it.
       Sheet-only exception: on touch there is nothing to leave. */
    if (pick) {
      pick.addEventListener('mouseleave', function () { if (!pickIsSheet()) openPick(false); });
      document.addEventListener('click', function (e) {
        if (!pickIsOpen()) return;
        if (wasDrag(e)) return;                    /* a scroll gesture, not a dismissal */
        /* Drilling into a pane re-renders the column, which DETACHES the very
           node that was clicked — so by the time the event reaches `document`,
           `pick.contains(e.target)` says "outside" and this would close the
           picker one tap into the drill-down. The composed path was captured at
           dispatch and still names the ancestors, so test that instead. */
        var path = e.composedPath && e.composedPath();
        var inside = path ? path.indexOf(pick) >= 0 : pick.contains(e.target);
        /* On the sheet the backdrop is `.kld-mx__pick::before`, and a click on a
           pseudo-element targets its host — so the host itself, hit directly,
           IS the backdrop and has to close. Anything deeper is the sheet. */
        if (inside && e.target !== pick) return;
        openPick(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && pickIsOpen()) openPick(false);
      });
    }

    if (findIn) findIn.addEventListener('input', function () { findQ = findIn.value; renderAll(); });
    root.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mx-clear-search]')) return;
      findQ = '';
      if (findIn) { findIn.value = ''; findIn.focus(); }
      renderAll();
    });

    /* Quantity entry is delegated on the whole root so the desktop grid and the
       mobile card list share one set of handlers — both layouts render the same
       `.kld-mx__qty` / [data-mx-bump] / [data-mx-unit] hooks. */
    root.addEventListener('input', function (e) {
      var inp = e.target.closest('.kld-mx__qty');
      if (!inp) return;
      setCellUnit(inp.getAttribute('data-sku'), inp.value);
      recalc();
    });
    root.addEventListener('focusin', function (e) {
      var inp = e.target.closest('.kld-mx__qty');
      if (inp) inp.select();
    });
    /* −/+ step by one unit of whatever the cell is set to (a bax, or a piece) */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mx-bump]');
      if (!btn) return;
      var sku = btn.getAttribute('data-sku'), x = SKUX[sku];
      if (!x) return;
      var step = uOf(sku) === 'bax' ? x.moq : 1;
      setCell(sku, (qty[sku] || 0) + (parseInt(btn.getAttribute('data-mx-bump'), 10) || 0) * step);
      recalc();
    });
    /* BAX ⇄ BUC swaps WHICH VARIANT the cell orders. Each side is its own SKU
       with its own price and stock, so the quantity typed for one does not
       carry over to the other — switching leaves the other side's quantity
       untouched and simply shows it. */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mx-unit]');
      if (!btn || btn.disabled) return;
      var cell = btn.getAttribute('data-cell');
      var want = btn.getAttribute('data-mx-unit');
      if (!cell || !SKUX[cell] || uOf(cell) === want) return;
      unitBy[cell] = want;
      renderAll();
    });

    if (tbody) {
      /* Enter/↓ next row · ↑ previous · ←→ across (only at the caret edges, so
         they still move the caret inside a value) — mirrors the prototype.
         Grid-only: the mobile cards are a single column of packagings. */
      tbody.addEventListener('keydown', function (e) {
        var inp = e.target.closest('.kld-mx__qty');
        if (!inp) return;
        var r = parseInt(inp.getAttribute('data-r'), 10), c = parseInt(inp.getAttribute('data-c'), 10);
        var to = null;
        if (e.key === 'Enter' || e.key === 'ArrowDown') to = [r + 1, c];
        else if (e.key === 'ArrowUp') to = [r - 1, c];
        else if (e.key === 'ArrowRight' && inp.selectionStart === inp.value.length) to = [r, c + 1];
        else if (e.key === 'ArrowLeft' && inp.selectionStart === 0) to = [r, c - 1];
        if (!to) return;
        var next = tbody.querySelector('.kld-mx__qty[data-r="' + to[0] + '"][data-c="' + to[1] + '"]');
        if (!next) return;
        e.preventDefault();
        next.focus(); next.select();
      });
    }

    /* mobile: the summary sheet over the sticky bar */
    if (sheet) {
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-mx-sheet-open]')) { sheet.hidden = false; recalc(); return; }
        if (e.target === sheet || e.target.closest('[data-mx-sheet-close]')) sheet.hidden = true;
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) sheet.hidden = true; });
    }

    /* mobile: expand/collapse a product card */
    if (cardsWrap) cardsWrap.addEventListener('click', function (e) {
      var h = e.target.closest('[data-mx-card-toggle]');
      if (!h) return;
      var k = h.getAttribute('data-mx-card-toggle');
      openCards[k] = !openCards[k];
      var card = h.closest('.kld-mxm__card');
      if (card) card.classList.toggle('is-open', !!openCards[k]);
    });

    /* Delegated: there are two ramburs checkboxes (cascade card + mobile sheet)
       and they mirror one flag. */
    root.addEventListener('change', function (e) {
      var box = e.target.closest('[data-mx-ramburs]');
      if (!box) return;
      ramburs = box.checked;
      recalc();
      /* Persist to the same cart attribute the cart widget writes, so the two
         previews and the applied discount stay on one declaration. */
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { payment_pref: ramburs ? 'ramburs' : 'standard' } })
      }).catch(function (err) { console.error('[mx-cascade] payment_pref update failed', err); });
    });

    /* Delegated too — the toolbar buttons exist once, but the mobile layout
       re-uses the same head, and the sheet adds a second "golește". */
    scope.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mx-clear]')) return;
      qty = {};
      renderAll();
      kldToast('Grilă golită');
    });

    /* ---- paste-from-Excel modal ---- */
    var modal = root.querySelector('[data-mx-modal]');
    var pasteTxt = root.querySelector('[data-mx-paste-text]');
    var pasteRes = root.querySelector('[data-mx-paste-res]');
    var closeModal = function () { if (modal) modal.hidden = true; };
    if (modal) scope.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mx-paste-open]')) return;
      if (pasteRes) { pasteRes.hidden = true; pasteRes.innerHTML = ''; }
      modal.hidden = false;
      if (pasteTxt) pasteTxt.focus();
    });
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('[data-mx-modal-close]')) closeModal();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    }
    var pasteRun = root.querySelector('[data-mx-paste-run]');
    if (pasteRun && pasteTxt) pasteRun.addEventListener('click', function () {
      var ok = 0, bad = [], elsewhere = 0;
      pasteTxt.value.split(/\r?\n/).forEach(function (ln) {
        if (!ln.trim()) return;
        /* Real column separators first (tab / ; / ,). Only if the line has none
           do we fall back to "everything up to the trailing number is the code"
           — splitting on single spaces would shred the SKUs that contain them. */
        var raw = ln.trim(), code = '', n = NaN;
        var parts = raw.split(/[\t;,]+/).filter(function (x) { return x.trim(); });
        if (parts.length >= 2) {
          code = parts[0];
          /* first purely numeric column after the code — tolerates the extra
             descriptive columns people keep in their order spreadsheets */
          for (var i = 1; i < parts.length; i++) {
            if (/^\d+$/.test(parts[i].trim())) { n = parseInt(parts[i], 10); break; }
          }
        } else {
          var m = raw.match(/^(.*?)\s+(\d+)\s*$/);
          if (m) { code = m[1]; n = parseInt(m[2], 10); }
        }
        var sku = SKUFIND[mxKey(code)];
        if (sku && n > 0) {
          qty[sku] = (qty[sku] || 0) + n;
          /* A pasted bax code has to flip its cell to BAX, otherwise the grid
             keeps showing the loose variant's (empty) input and the quantity
             lands only in the totals. */
          var x = SKUX[sku];
          if (x.isBax && x.cell) unitBy[x.cell] = 'bax';
          else if (x.cell) unitBy[x.cell] = 'buc';
          if (x.cat !== catId) elsewhere++;
          ok++;
        } else bad.push(raw);
      });
      renderAll();
      if (pasteRes) {
        pasteRes.hidden = false;
        pasteRes.innerHTML = '<div class="ok">' + ok + (ok === 1 ? ' linie importată.' : ' linii importate.') +
            (elsewhere ? ' <span class="muted">(' + elsewhere + ' în alte categorii)</span>' : '') + '</div>' +
          (bad.length ? '<div class="bad">Necunoscute: ' + esc(bad.slice(0, 4).join(' · ')) + (bad.length > 4 ? ' …' : '') + '</div>' : '');
      }
    });

    if (saveBtn) saveBtn.addEventListener('click', function () {
      var n = Object.keys(qty).filter(function (s) { return qty[s] > 0; }).length;
      kldToast('Salvat ca listă recurentă (' + n + (n === 1 ? ' linie)' : ' linii)'));
    });

    /* ---- add everything to the cart (grid summary card + mobile bar CTA) ---- */
    root.addEventListener('click', function (e) {
      var clicked = e.target.closest('[data-mx-addall]');
      if (!clicked) return;
      var lines = Object.keys(qty).filter(function (s) { return qty[s] > 0 && SKUX[s]; });
      if (!lines.length) return;
      var desired = {}, missing = [];
      lines.forEach(function (s) {
        var vid = vids[normKey(s)];
        if (vid) desired[vid] = (desired[vid] || 0) + qty[s];
        else missing.push(s);
      });
      if (!Object.keys(desired).length) {
        kldToast(dynamic
          ? 'Niciun cod din grilă nu are corespondent în magazin — verifică SKU-urile.'
          : 'Mod demo — activează „Rezolvă SKU-urile din magazin” în setările secțiunii.');
        return;
      }
      setAddDisabled(true);
      /* Same reconciliation as Quick Order: /cart/add.js is additive + atomic, so
         send only the delta vs what the live cart already holds. */
      var buildAndAdd = function (inCart) {
        var items = [];
        Object.keys(desired).forEach(function (vid) {
          var delta = desired[vid] - (inCart[vid] || 0);
          if (delta > 0) items.push({ id: parseInt(vid, 10) || vid, quantity: delta });
        });
        if (!items.length) { setAddDisabled(false); kldToast('Toate produsele din grilă sunt deja în coș.'); return; }
        /* kldAjaxAddItems re-enables the button it was handed; the other layout's
           twin is hidden anyway, and the next recalc syncs both. */
        kldAjaxAddItems(items, clicked, cartUrl, function () {
          setAddDisabled(false);
          if (missing.length) kldToast(missing.length + ' cod(uri) fără corespondent în magazin: ' + missing.slice(0, 3).join(', '));
        });
      };
      if (window.fetch) {
        fetch(kldUrl('cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            var inCart = {};
            if (cart && cart.items) cart.items.forEach(function (it) { inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity; });
            buildAndAdd(inCart);
          })
          .catch(function () { buildAndAdd({}); });
      } else {
        buildAndAdd({});
      }
    });

    renderAll();

    /* Resolve the grid's SKUs against the published store so "add all" adds real
       variants. Purely additive — the grid stays usable while this is in flight. */
    if (dynamic && window.fetch) {
      loadProductsJson(root.getAttribute('data-mx-products-url') || '/products.json', function (list) {
        (list || []).forEach(function (p) {
          var k = normKey(p.sku);
          if (p.vid && k && !vids[k]) vids[k] = p.vid;   /* catalog ids win */
        });
      });
    }
  }

  function boot(scope) {
    var s = scope || document;
    initCartUpdateBridge();
    s.querySelectorAll('.klh2').forEach(initHeader);
    s.querySelectorAll('.klf2').forEach(initFooter);
    s.querySelectorAll('.kld').forEach(initKldPage);
    s.querySelectorAll('.kld').forEach(initKldModals);
    s.querySelectorAll('.kld').forEach(initKldDrill);
    s.querySelectorAll('.kld').forEach(initKldToasts);
    s.querySelectorAll('.kld').forEach(initKldCartAdd);
    /* Portal (.klp) recommendation cards use the same form[data-kld-add] AJAX
       add-to-cart + Dawn cart-drawer refresh as the .kld pages. */
    s.querySelectorAll('.klp').forEach(initKldCartAdd);
    s.querySelectorAll('.kld').forEach(initKldPromo);
    s.querySelectorAll('[data-kld-builder]').forEach(initKldBuilder);
    s.querySelectorAll('[data-kld-sidenav]').forEach(initKldSideNav);
    s.querySelectorAll('[data-kld-facets]').forEach(initKldFacets);
    s.querySelectorAll('[data-kld-catalog]').forEach(initKldFilterDrawer);
    s.querySelectorAll('[data-kld-catalog]').forEach(initKldCatalog);
    s.querySelectorAll('[data-kld-quick-order]').forEach(initKldQuickOrder);
    s.querySelectorAll('[data-kld-matrix-order]').forEach(initKldMatrixOrder);
    s.querySelectorAll('[data-kld-resurse]').forEach(initKldResurse);
    s.querySelectorAll('.kld-tabs').forEach(initTabs);
    /* Read from the document, not the boot scope: a section reload hands us just
       that section, and the flag must survive it. Sticky once set, so reloading
       some OTHER section cannot turn the buttons back on. */
    if (document.querySelector('[data-kld-hide-widgets]')) kldPandectesOff = true;
    kldLiftWidgets();
  }

  /* ============================================================
     Keep the Pandectes floating buttons clear of the mobile bottom chrome
     (the blue tab bar everywhere; Matrix Order's taller white total bar there).

     This has to be JS, and it has to write `bottom` inline. Verified against the
     live storefront:
       • Both widgets live in SHADOW DOM (<pandectes-cmp>, <pandectes-a11y>), so
         no page stylesheet reaches them at any specificity.
       • A stylesheet adopted INTO the shadow root still loses: adopted sheets
         are ordered before the root's own <style> elements, so their rules win
         ties on !important.
       • `transform` is a dead end on the accessibility button — even
         `transform: translateY(-44px) !important` in its style attribute
         computes to the identity matrix and it does not move. (It works on the
         cookie button, but one mechanism for both is worth more.)
       • Writing `bottom` inline DOES work on both: 741px → 651px when set.

     Their own inline style is `left: 15px !important; bottom: 70px !important`,
     so we write the same property with the same priority and simply win by
     being later. Each button's natural offset is cached the first time it is
     seen, and every button gets the SAME lift, so the gap the app chose between
     them is preserved. ============================================================ */
  var KLD_CHROME_SEL = '.klh2-bottomtabs, .kld-mxm__bar';
  var KLD_PANDECTES_SEL = 'pandectes-a11y, pandectes-cmp';
  var KLD_WIDGET_SEL = '.widget.bottom.left';
  var KLD_WIDGET_GAP = 14;   /* breathing room between button and chrome */
  var KLD_WIDGET_BP = 980;   /* matches the mobile breakpoint in the CSS */
  /* set by a page carrying [data-kld-hide-widgets] — see kldLiftWidgets */
  var kldPandectesOff = false;
  var kldChromeRO = null;
  var kldLiftQueued = false;
  var kldLiftTries = 0;

  function kldLiftWidgets() {
    /* Watchers first — they must survive the "no buttons yet" bail below. The
       widget apps mount long after DOMContentLoaded, so the very first call
       always finds nothing; binding after the bail meant nothing was ever
       watching and the lift never ran at all. */
    kldBindLiftWatchers();

    /* tallest fixed chrome pinned to the bottom. Re-queried every time so a
       section reload can't leave us measuring detached nodes; display:none
       above the breakpoint gives 0, which is the right answer there. */
    var chrome = 0;
    var bars = document.querySelectorAll(KLD_CHROME_SEL);
    bars.forEach(function (el) { if (el.offsetHeight > chrome) chrome = el.offsetHeight; });
    if (window.ResizeObserver && bars.length) {
      if (kldChromeRO) kldChromeRO.disconnect();
      kldChromeRO = new ResizeObserver(kldQueueLift);
      bars.forEach(function (el) { kldChromeRO.observe(el); });
    }

    var btns = [];
    document.querySelectorAll(KLD_PANDECTES_SEL).forEach(function (host) {
      var sr = host.shadowRoot;
      if (!sr) return;
      /* the cookie button only exists once consent has been given, and the apps
         re-render — watch for both */
      if (!sr.kldLiftWatched && window.MutationObserver) {
        sr.kldLiftWatched = 1;
        new MutationObserver(kldQueueLift).observe(sr, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['style']
        });
      }
      var btn = sr.querySelector(KLD_WIDGET_SEL);
      if (!btn) return;
      /* cache the app's own offset BEFORE we ever write one, or each pass would
         measure our own value back and drift upwards */
      if (btn.kldBaseBottom === undefined) {
        btn.kldBaseBottom = parseFloat(getComputedStyle(btn).bottom) || 0;
      }
      btns.push(btn);
    });
    if (!btns.length) {
      /* Nothing to lift yet. The body observer only fires when a HOST is added,
         which misses the case where the host is already there but its shadow
         root / button renders later — so poll briefly as well. Bounded, and
         reset as soon as the buttons turn up. */
      if (kldLiftTries < 30) {
        kldLiftTries++;
        setTimeout(kldQueueLift, 400);
      }
      return;
    }
    kldLiftTries = 0;

    /* Page opted out of the floating buttons ([data-kld-hide-widgets]).
       The BUTTONS are hidden, not their hosts: hiding a host would also
       suppress the Pandectes consent banner, which must still be able to
       appear for a visitor who has not answered it yet. Writing `display`
       inline with priority is the same mechanism the lift below uses, and for
       the same reason — nothing in the shadow root can outrank it. Re-applied
       on every pass, so the apps' own re-renders cannot bring them back. */
    if (kldPandectesOff) {
      btns.forEach(function (btn) {
        /* already hidden → don't rewrite, or our own style observer spins */
        if (btn.style.getPropertyValue('display') === 'none') return;
        btn.style.setProperty('display', 'none', 'important');
      });
      return;
    }

    /* one lift for all of them, sized off the LOWEST button, so their relative
       spacing survives */
    var lift = 0;
    if (chrome > 0 && window.innerWidth <= KLD_WIDGET_BP) {
      var lowest = btns[0].kldBaseBottom;
      btns.forEach(function (b) { if (b.kldBaseBottom < lowest) lowest = b.kldBaseBottom; });
      lift = Math.max(0, chrome + KLD_WIDGET_GAP - lowest);
    }
    btns.forEach(function (btn) {
      var want = (btn.kldBaseBottom + lift) + 'px';
      /* skip when already correct: writing an identical value would trip our own
         style-attribute observer and spin. Comparing against what is actually on
         the element (not a remembered value) still lets us win it back if the
         app overwrites the attribute. */
      if (btn.style.getPropertyValue('bottom') === want &&
          btn.style.getPropertyPriority('bottom') === 'important') return;
      btn.style.setProperty('bottom', want, 'important');
    });
  }

  /* Hide the Pandectes floating buttons while the mobile drawer is open.

     They cannot be out-stacked: their hosts carry `z-index: 2147483647`, the
     maximum, so no drawer z-index wins. Lowering it is no good either — behind
     a semi-transparent scrim they would still show through as dimmed blobs.
     Hiding the HOST is the clean option, and unlike their inner button the host
     is ordinary light DOM we can reach. `display` is set inline with priority so
     nothing inside the shadow root can override it, and the previous value is
     restored on close rather than blindly cleared. */
  function kldHidePandectes(hide) {
    document.querySelectorAll(KLD_PANDECTES_SEL).forEach(function (host) {
      if (hide) {
        if (host.kldPrevDisplay === undefined) {
          host.kldPrevDisplay = host.style.getPropertyValue('display');
        }
        host.style.setProperty('display', 'none', 'important');
      } else if (host.kldPrevDisplay !== undefined) {
        if (host.kldPrevDisplay) host.style.setProperty('display', host.kldPrevDisplay);
        else host.style.removeProperty('display');
        host.kldPrevDisplay = undefined;
      }
    });
  }

  function kldBindLiftWatchers() {
    if (kldLiftWidgets.bound || !document.body) return;
    kldLiftWidgets.bound = 1;
    window.addEventListener('resize', kldQueueLift);
    /* the widget apps mount asynchronously; both hosts are direct children of
       <body>, so a shallow childList observer is enough to catch them */
    if (window.MutationObserver) {
      new MutationObserver(function (recs) {
        for (var i = 0; i < recs.length; i++) {
          for (var j = 0; j < recs[i].addedNodes.length; j++) {
            var n = recs[i].addedNodes[j];
            if (n.nodeType === 1 && n.matches && n.matches(KLD_PANDECTES_SEL)) return kldQueueLift();
          }
        }
      }).observe(document.body, { childList: true });
    }
  }

  /* coalesce bursts (the widgets re-render while animating) into one frame */
  function kldQueueLift() {
    if (kldLiftQueued) return;
    kldLiftQueued = true;
    requestAnimationFrame(function () {
      kldLiftQueued = false;
      kldLiftWidgets();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
